// import React, { useContext, useEffect, useState } from "react";
// import { createPortal, flushSync } from "react-dom";
// import { createRoot } from "react-dom/client";
// import { AnimatePresence, motion } from "framer-motion";
// import {
//   BriefcaseBusiness,
//   CalendarClock,
//   Coins,
//   FileDown,
//   FileSpreadsheet,
//   FileText,
//   Globe2,
//   GraduationCap,
//   Hash,
//   ImagePlus,
//   Languages,
//   MapPin,
//   Presentation,
//   Target,
//   UserRound,
// } from "lucide-react";
// import Swal from "sweetalert2";
// import LoadingIcon from "../../images/Loading_icon.gif";
// import bulkPdfFirstPage from "../../images/bulk_pdf_first_page.png";
// import bulkPdfLastPage from "../../images/bulk_pdf_last_page.png";
// import { UrlContext } from "../../contexts/UrlContext";
// import { UserContext } from "../../contexts/UserContext";
// import { ensureConnectionAndExecute } from "../../utils/eph-connection-manager";
// import { pollTaskStatus } from "../../utils/taskStatus";
// import DigitalProfileSlide from "../PreviewDigitalPPT/DigitalProfileSlide";
// import "../../styles/previewDigitalPPTBrowser.css";
// import "react-quill/dist/quill.snow.css";


// const FILE_FORMAT_LABELS = {
//   word: "Word",
//   ppt: "PPTX",
//   excel: "Excel",
// };


// const DEFAULT_BULK_PDF_SECTION_VISIBILITY = {
//   profilePicture: true,
//   identity: true,
//   position: true,
//   location: true,
//   region: false,
//   language: true,
//   totalExperience: true,
//   availability: true,
//   rate: true,
//   summary: true,
//   matching: true,
//   experience: true,
//   education: true,
// };

// function BulkPdfSectionToggle({
//   checked,
//   onChange,
//   icon: Icon,
//   label,
//   description,
// }) {
//   return (
//     <button
//       type="button"
//       className={`pdp2-section-option${checked ? " is-active" : ""}`}
//       onClick={onChange}
//       aria-pressed={checked}
//     >
//       <span className="pdp2-section-option-icon" aria-hidden="true">
//         <Icon size={17} strokeWidth={2} />
//       </span>
//       <span className="pdp2-section-option-copy">
//         <strong>{label}</strong>
//         <small>{description}</small>
//       </span>
//       <span className="pdp2-section-option-switch" aria-hidden="true">
//         <span />
//       </span>
//     </button>
//   );
// }

// function BulkPdfSectionSelectionModal({
//   open,
//   sectionVisibility,
//   identityMode,
//   onToggleSection,
//   onIdentitySelection,
//   onClose,
//   onConfirm,
// }) {
//   if (typeof document === "undefined") return null;

//   const informationOptions = [
//     { key: "profilePicture", label: "Profile picture", description: "Consultant profile photo", icon: ImagePlus, checked: sectionVisibility.profilePicture, onChange: () => onToggleSection("profilePicture") },
//     { key: "ephId", label: "EPH ID", description: "EPH_CON_ / EPH_EXP_ identifier", icon: Hash, checked: sectionVisibility.identity && identityMode === "id", onChange: () => onIdentitySelection("id") },
//     { key: "name", label: "Name", description: "Consultant name", icon: UserRound, checked: sectionVisibility.identity && identityMode === "name", onChange: () => onIdentitySelection("name") },
//     { key: "position", label: "Position", description: "Current role or headline", icon: BriefcaseBusiness, checked: sectionVisibility.position, onChange: () => onToggleSection("position") },
//     { key: "location", label: "Location", description: "Current consultant location", icon: MapPin, checked: sectionVisibility.location, onChange: () => onToggleSection("location") },
//     { key: "region", label: "Region", description: "Regional experience", icon: Globe2, checked: sectionVisibility.region, onChange: () => onToggleSection("region") },
//     { key: "language", label: "Languages", description: "Language capabilities", icon: Languages, checked: sectionVisibility.language, onChange: () => onToggleSection("language") },
//     { key: "totalExperience", label: "Total experience", description: "Years of professional experience", icon: BriefcaseBusiness, checked: sectionVisibility.totalExperience, onChange: () => onToggleSection("totalExperience") },
//     { key: "availability", label: "Availability", description: "Current availability note", icon: CalendarClock, checked: sectionVisibility.availability, onChange: () => onToggleSection("availability") },
//     { key: "rate", label: "Rate", description: "Currency, rate and billing unit", icon: Coins, checked: sectionVisibility.rate, onChange: () => onToggleSection("rate") },
//   ];

//   const contentOptions = [
//     { key: "summary", label: "Professional Summary", description: "Main consultant summary", icon: FileText, checked: sectionVisibility.summary, onChange: () => onToggleSection("summary") },
//     { key: "matching", label: "Requirement Matching", description: "Dimensions and radar matching", icon: Target, checked: sectionVisibility.matching, onChange: () => onToggleSection("matching") },
//     { key: "experience", label: "Relevant Experience", description: "Selected professional experience", icon: BriefcaseBusiness, checked: sectionVisibility.experience, onChange: () => onToggleSection("experience") },
//     { key: "education", label: "Education & Certification", description: "Education and credentials", icon: GraduationCap, checked: sectionVisibility.education, onChange: () => onToggleSection("education") },
//   ];

//   const informationActiveCount = informationOptions.filter((option) => option.checked).length;
//   const contentActiveCount = contentOptions.filter((option) => option.checked).length;

//   return createPortal(
//     <AnimatePresence>
//       {open && (
//         <motion.div
//           className="fixed inset-0 z-[10050] flex items-center justify-center bg-slate-950/45 p-4 backdrop-blur-sm sm:p-6"
//           initial={{ opacity: 0 }}
//           animate={{ opacity: 1 }}
//           exit={{ opacity: 0 }}
//           transition={{ duration: 0.16 }}
//           role="presentation"
//           data-pdp2-print-hide="true"
//           onMouseDown={(event) => {
//             if (event.target === event.currentTarget) onClose();
//           }}
//         >
//           <motion.div
//             className="pdp2-section-picker flex max-h-[90vh] w-[min(1080px,calc(100vw-32px))] flex-col overflow-hidden rounded-[26px] border border-slate-200/90 bg-[radial-gradient(circle_at_top,rgba(54,85,97,0.14),transparent_34%),linear-gradient(to_bottom,#f8fafc,#eef2f6)] shadow-[0_28px_90px_rgba(15,23,42,0.34)]"
//             initial={{ opacity: 0, y: 22, scale: 0.975 }}
//             animate={{ opacity: 1, y: 0, scale: 1 }}
//             exit={{ opacity: 0, y: 18, scale: 0.98 }}
//             transition={{ type: "spring", stiffness: 340, damping: 30, mass: 0.82 }}
//             role="dialog"
//             aria-modal="true"
//             aria-labelledby="bulk-pdf-section-picker-title"
//             onMouseDown={(event) => event.stopPropagation()}
//           >
//             <div className="pdp2-section-picker-header">
//               <div className="pdp2-section-picker-title-wrap">
//                 <span className="pdp2-section-picker-eyebrow">Bulk PDF layout</span>
//                 <strong id="bulk-pdf-section-picker-title">Choose visible sections</strong>
//                 <p>Choose which information and content blocks should appear on every selected digital profile in this PDF. This selection is used only for the PDF and is not saved to the profile.</p>
//               </div>
//               <button type="button" className="pdp2-section-picker-close" onClick={onClose} aria-label="Close bulk PDF section picker">×</button>
//             </div>

//             <div className="pdp2-section-picker-body">
//               <div className="pdp2-section-picker-sections">
//                 <section className="pdp2-section-picker-panel pdp2-section-picker-panel-information">
//                   <div className="pdp2-section-picker-panel-header">
//                     <div className="pdp2-section-picker-panel-title">
//                       <span className="pdp2-section-picker-panel-icon"><UserRound size={17} strokeWidth={2} /></span>
//                       <div><strong>Information</strong><small>Left-side consultant details</small></div>
//                     </div>
//                     <span className="pdp2-section-picker-count">{informationActiveCount}/{informationOptions.length}</span>
//                   </div>
//                   <div className="pdp2-section-picker-grid pdp2-section-picker-grid-information">
//                     {informationOptions.map((option) => (
//                       <BulkPdfSectionToggle key={option.key} checked={option.checked} onChange={option.onChange} icon={option.icon} label={option.label} description={option.description} />
//                     ))}
//                   </div>
//                   <div className="pdp2-section-picker-note">
//                     <Hash size={13} strokeWidth={2} />
//                     <span><strong>EPH ID</strong> and <strong>Name</strong> share the same profile area and are mutually exclusive.</span>
//                   </div>
//                 </section>

//                 <section className="pdp2-section-picker-panel pdp2-section-picker-panel-content">
//                   <div className="pdp2-section-picker-panel-header">
//                     <div className="pdp2-section-picker-panel-title">
//                       <span className="pdp2-section-picker-panel-icon"><FileText size={17} strokeWidth={2} /></span>
//                       <div><strong>Content</strong><small>Main profile sections</small></div>
//                     </div>
//                     <span className="pdp2-section-picker-count">{contentActiveCount}/{contentOptions.length}</span>
//                   </div>
//                   <div className="pdp2-section-picker-grid pdp2-section-picker-grid-content">
//                     {contentOptions.map((option) => (
//                       <BulkPdfSectionToggle key={option.key} checked={option.checked} onChange={option.onChange} icon={option.icon} label={option.label} description={option.description} />
//                     ))}
//                   </div>
//                 </section>
//               </div>
//             </div>

//             <div className="flex shrink-0 items-center justify-end gap-2 border-t border-slate-200/90 bg-white/85 px-5 py-4 backdrop-blur-sm">
//               <button type="button" className="rounded-xl border border-slate-200 bg-white px-4 py-2 text-sm font-semibold text-slate-600 transition hover:bg-slate-50 focus:outline-none" onClick={onClose}>Cancel</button>
//               <button type="button" className="rounded-xl border-0 bg-[#365561] px-5 py-2 text-sm font-semibold text-white transition hover:bg-[#2e4a54] focus:outline-none" onClick={onConfirm}>Generate PDF</button>
//             </div>
//           </motion.div>
//         </motion.div>
//       )}
//     </AnimatePresence>,
//     document.body
//   );
// }

// function BulkPdfCoverPage({
//   projectName,
//   clientName,
//   projectType,
// }) {
//   const monthYear = new Intl.DateTimeFormat("en-US", {
//     month: "long",
//     year: "numeric",
//   })
//     .format(new Date())
//     .toUpperCase();

//   const deckTitle =
//     projectType === "exp"
//       ? "Selected Expert Profiles"
//       : "Selected Consulting Profiles";

//   return (
//     <div
//       className="pdp2-bulk-print-page relative h-[720px] w-[1280px] shrink-0 overflow-hidden bg-white"
//       data-pdp2-bulk-static-page="cover"
//     >
//       {/*
//         Use a real <img> rather than CSS background-image so the first
//         page is always included by the browser print engine even when
//         "Background graphics" is disabled.
//       */}
//       <img
//         src={bulkPdfFirstPage}
//         alt=""
//         aria-hidden="true"
//         className="absolute inset-0 h-full w-full select-none object-fill"
//         draggable="false"
//       />

//       <div
//         className="absolute text-white"
//         style={{
//           left: "10.2%",
//           top: "62.0%",
//           width: "64%",
//           fontFamily: "Arial, Helvetica, sans-serif",
//         }}
//       >
//         <div
//           style={{
//             fontSize: "32px",
//             lineHeight: 1.12,
//             fontWeight: 700,
//             letterSpacing: "-0.4px",
//           }}
//         >
//           {deckTitle}
//         </div>

//         <div
//           style={{
//             display: "flex",
//             alignItems: "flex-start",
//             gap: "0px",
//             marginTop: "17px",
//             fontSize: "23px",
//             lineHeight: 1.18,
//             fontWeight: 400,
//             width: "100%",
//           }}
//         >
//           <span
//             className="shrink-0"
//             style={{ minWidth: "66px" }}
//           >
//             Topic:
//           </span>

//           <span
//             style={{
//               display: "block",
//               width: "50ch",
//               maxWidth: "50ch",
//               flex: "0 0 50ch",
//               fontWeight: 400,
//               whiteSpace: "normal",
//               overflowWrap: "break-word",
//               wordBreak: "normal",
//             }}
//           >
//             {projectName || ""}
//           </span>
//         </div>
//       </div>

//       <div
//         className="absolute text-white"
//         style={{
//           left: "10.2%",
//           top: "82.4%",
//           width: "64%",
//           fontFamily: "Arial, Helvetica, sans-serif",
//         }}
//       >
//         <div
//           style={{
//             display: "flex",
//             alignItems: "baseline",
//             gap: "6px",
//             fontSize: "20px",
//             lineHeight: 1.2,
//             whiteSpace: "nowrap",
//           }}
//         >
//           <span style={{ fontWeight: 700 }}>
//             Prepared for
//           </span>
//           <span
//             style={{
//               fontWeight: 600,
//               minWidth: 0,
//               whiteSpace: "nowrap",
//             }}
//           >
//             {clientName || ""}
//           </span>
//         </div>
//       </div>

//       <div
//         className="absolute text-[#365561]"
//         style={{
//           left: "10.2%",
//           top: "93.5%",
//           width: "50%",
//           fontFamily: "Arial, Helvetica, sans-serif",
//           fontSize: "17px",
//           lineHeight: 1.2,
//           fontWeight: 700,
//         }}
//       >
//         {monthYear}
//       </div>
//     </div>
//   );
// }

// function BulkPdfLastPage({
//   contactName,
//   contactEmail,
// }) {
//   return (
//     <div
//       className="pdp2-bulk-print-page relative h-[720px] w-[1280px] shrink-0 overflow-hidden bg-[#365561]"
//       data-pdp2-bulk-static-page="outro"
//     >
//       <img
//         src={bulkPdfLastPage}
//         alt=""
//         aria-hidden="true"
//         className="absolute inset-0 h-full w-full select-none object-fill"
//         draggable="false"
//       />

//       <div
//         className="absolute text-white"
//         style={{
//           left: "60.7%",
//           top: "4.0%",
//           width: "34.5%",
//           fontFamily: "Arial, Helvetica, sans-serif",
//         }}
//       >
//         <div
//           style={{
//             fontSize: "28px",
//             lineHeight: 1.24,
//             fontWeight: 700,
//             letterSpacing: "-0.35px",
//           }}
//         >
//           Let us find the right expertise
//           <br />
//           for your project
//         </div>

//         <div
//           style={{
//             marginTop: "31px",
//             fontSize: "17px",
//             lineHeight: 1.25,
//             fontWeight: 400,
//           }}
//         >
//           Reach out to your Contact
//         </div>

//         <div
//           style={{
//             marginTop: "6px",
//             fontSize: "17px",
//             lineHeight: 1.28,
//             fontWeight: 600,
//             overflowWrap: "anywhere",
//           }}
//         >
//           {contactName || ""}
//         </div>

//         <div
//           style={{
//             marginTop: "1px",
//             fontSize: "17px",
//             lineHeight: 1.28,
//             fontWeight: 600,
//             overflowWrap: "anywhere",
//           }}
//         >
//           {contactEmail || ""}
//         </div>

//         <div
//           style={{
//             marginTop: "66px",
//             fontSize: "17px",
//             lineHeight: 1.2,
//             fontWeight: 700,
//           }}
//         >
//           Cologne | Düsseldorf | Mumbai
//         </div>
//       </div>
//     </div>
//   );
// }

// function BulkDigitalProfileDeck({
//   profiles,
//   projectName,
//   clientName,
//   contactName,
//   contactEmail,
//   projectType,
//   sectionVisibility,
//   identityMode,
// }) {
//   return (
//     <div className="pdp2-page-shell pdp2-bulk-pdf-deck">
//       <BulkPdfCoverPage
//         projectName={projectName}
//         clientName={clientName}
//         projectType={projectType}
//       />

//       {profiles.map((profile, index) => (
//         <DigitalProfileSlide
//           key={profile?.ID || profile?.expertID || index}
//           readOnly
//           previewPrintLayout
//           showProposedRates={false}
//           sectionVisibility={sectionVisibility}
//           expertID={profile?.expertID || profile?.ID}
//           powerPointID={
//             profile?.powerPointID ||
//             profile?.powerpointID ||
//             profile?.PowerPointID ||
//             null
//           }
//           experienceData={
//             Array.isArray(profile?.expertExperience)
//               ? profile.expertExperience
//               : []
//           }
//           data={{
//             identityMode,
//             projectType: profile?.projectType,
//             profilePicture: profile?.profilePicture,
//             expertDigitalID: profile?.expertDigitalID,
//             expertName: profile?.expertName,
//             position: profile?.position,
//             location: profile?.location,
//             region: profile?.region,
//             language: profile?.language,
//             totalExperience: profile?.totalExperience,
//             availableComment: profile?.Available_comment,
//             projectCurrency: profile?.projectCurrency,
//             dailyRate: profile?.daily_rate,
//             billingFrequency: profile?.billingFrequency,
//             footNote: profile?.footNote,
//             summary: profile?.summ,
//             education: profile?.education,
//             dimensions: [
//               profile?.dimension1,
//               profile?.dimension2,
//               profile?.dimension3,
//               profile?.dimension4,
//               profile?.dimension5,
//             ],
//             ratings: [
//               Number(profile?.rating1) || 0,
//               Number(profile?.rating2) || 0,
//               Number(profile?.rating3) || 0,
//               Number(profile?.rating4) || 0,
//               Number(profile?.rating5) || 0,
//             ],
//           }}
//         />
//       ))}

//       <BulkPdfLastPage
//         contactName={contactName}
//         contactEmail={contactEmail}
//       />
//     </div>
//   );
// }

// function waitForBulkImages(root) {
//   const images = Array.from(
//     root?.querySelectorAll?.("img") || []
//   );

//   return Promise.all(
//     images.map((image) => {
//       if (image.complete) {
//         return Promise.resolve();
//       }

//       return new Promise((resolve) => {
//         image.onload = resolve;
//         image.onerror = resolve;
//       });
//     })
//   );
// }

// function waitForBulkStyles(doc) {
//   const stylesheetLinks = Array.from(
//     doc.querySelectorAll('link[rel="stylesheet"]')
//   );

//   return Promise.all(
//     stylesheetLinks.map((link) => {
//       if (link.sheet) {
//         return Promise.resolve();
//       }

//       return new Promise((resolve) => {
//         const done = () => resolve();

//         link.addEventListener("load", done, {
//           once: true,
//         });
//         link.addEventListener("error", done, {
//           once: true,
//         });

//         setTimeout(done, 3000);
//       });
//     })
//   );
// }

// function copyBulkDocumentStyles(printWindow) {
//   Array.from(
//     document.querySelectorAll(
//       'style, link[rel="stylesheet"]'
//     )
//   ).forEach((node) => {
//     try {
//       const clone = node.cloneNode(true);

//       if (
//         node.tagName === "LINK" &&
//         node.href
//       ) {
//         clone.href = node.href;
//       }

//       printWindow.document.head.appendChild(clone);
//     } catch (error) {
//       console.error(
//         "Failed to copy stylesheet into bulk PDF window:",
//         error
//       );
//     }
//   });
// }

// const BULK_PDF_PRINT_STYLE = `
//   @page {
//     size: 13.333333333in 7.5in;
//     margin: 0;
//   }

//   html,
//   body {
//     width: auto !important;
//     height: auto !important;
//     min-height: 0 !important;
//     margin: 0 !important;
//     padding: 0 !important;
//     overflow: visible !important;
//     background: #ffffff !important;
//     -webkit-print-color-adjust: exact !important;
//     print-color-adjust: exact !important;
//   }

//   #pdp2-bulk-print-root {
//     width: auto !important;
//     height: auto !important;
//     margin: 0 !important;
//     padding: 0 !important;
//     overflow: visible !important;
//   }

//   .pdp2-screen-only,
//   [data-pdp2-print-hide="true"] {
//     display: none !important;
//   }

//   .pdp2-print-only {
//     display: block !important;
//   }

//   /* The normal Preview stylesheet fixes .pdp2-page-shell to one print page.
//      The bulk deck is the only exception: it must be allowed to contain many
//      otherwise-standard DigitalProfileSlide pages. */
//   .pdp2-page-shell.pdp2-bulk-pdf-deck {
//     width: auto !important;
//     height: auto !important;
//     min-height: 0 !important;
//     margin: 0 !important;
//     padding: 0 !important;
//     overflow: visible !important;
//     background: #ffffff !important;
//   }

//   .pdp2-bulk-pdf-deck > .pdp2-slide,
//   .pdp2-bulk-pdf-deck > [data-pdp2-bulk-static-page] {
//     width: 13.333333333in !important;
//     height: 7.5in !important;
//     min-width: 13.333333333in !important;
//     min-height: 7.5in !important;
//     max-width: 13.333333333in !important;
//     max-height: 7.5in !important;
//     margin: 0 !important;
//     box-shadow: none !important;
//     overflow: hidden !important;
//     break-after: page !important;
//     page-break-after: always !important;
//     -webkit-print-color-adjust: exact !important;
//     print-color-adjust: exact !important;
//   }

//   .pdp2-bulk-pdf-deck > :last-child {
//     break-after: auto !important;
//     page-break-after: auto !important;
//   }

//   .pdp2-bulk-pdf-deck
//     [data-pdp2-bulk-static-page]
//     > img {
//     position: absolute !important;
//     inset: 0 !important;
//     width: 100% !important;
//     height: 100% !important;
//     max-width: none !important;
//     max-height: none !important;
//     object-fit: fill !important;
//   }
// `;

// function freezeBulkSlideGeometry(sourceDeck, clonedDeck) {
//   const sourceSlides = Array.from(
//     sourceDeck.querySelectorAll(":scope > .pdp2-slide")
//   );
//   const clonedSlides = Array.from(
//     clonedDeck.querySelectorAll(":scope > .pdp2-slide")
//   );

//   const sectionSelectors = [
//     ".pdp2-summary-section",
//     ".pdp2-matching-section",
//     ".pdp2-experience-section",
//     ".pdp2-education-section",
//   ];

//   sourceSlides.forEach((sourceSlide, slideIndex) => {
//     const clonedSlide = clonedSlides[slideIndex];
//     if (!clonedSlide) return;

//     // The standard Preview slide is already laid out correctly in the active
//     // document. Freeze those calculated section heights onto the clone so the
//     // multi-page print wrapper cannot make Flexbox recalculate them differently.
//     sectionSelectors.forEach((selector) => {
//       const sourceSection = sourceSlide.querySelector(selector);
//       const clonedSection = clonedSlide.querySelector(selector);

//       if (!sourceSection || !clonedSection) return;

//       const height = sourceSection.getBoundingClientRect().height;
//       if (!Number.isFinite(height) || height <= 0) return;

//       clonedSection.style.height = `${height}px`;
//       clonedSection.style.flex = `0 0 ${height}px`;
//     });

//     // Keep the two 600px content columns at the exact same runtime height as
//     // PreviewDigitalPPT as well. This is only a snapshot of the shared layout;
//     // it does not introduce any new design dimensions.
//     [".pdp2-center-column", ".pdp2-right-column"].forEach(
//       (selector) => {
//         const sourceColumn = sourceSlide.querySelector(selector);
//         const clonedColumn = clonedSlide.querySelector(selector);

//         if (!sourceColumn || !clonedColumn) return;

//         const height = sourceColumn.getBoundingClientRect().height;
//         if (!Number.isFinite(height) || height <= 0) return;

//         clonedColumn.style.height = `${height}px`;
//       }
//     );
//   });
// }

// async function prepareBulkPdfPrintWindow(
//   printWindow,
//   sourceHost,
//   title
// ) {
//   printWindow.document.open();
//   printWindow.document.write(`
//     <!doctype html>
//     <html>
//       <head>
//         <meta charset="utf-8" />
//         <title></title>
//       </head>
//       <body>
//         <div id="pdp2-bulk-print-root"></div>
//       </body>
//     </html>
//   `);
//   printWindow.document.close();

//   printWindow.document.title = title;

//   copyBulkDocumentStyles(printWindow);

//   const printStyle =
//     printWindow.document.createElement("style");

//   printStyle.textContent = BULK_PDF_PRINT_STYLE;
//   printWindow.document.head.appendChild(printStyle);

//   const sourceDeck = sourceHost.querySelector(
//     ".pdp2-bulk-pdf-deck"
//   );

//   if (!sourceDeck) {
//     throw new Error(
//       "Bulk digital profile slides could not be rendered."
//     );
//   }

//   const clonedDeck = sourceDeck.cloneNode(true);

//   // Preserve the exact section allocation that the shared DigitalProfileSlide
//   // calculated in the parent document before the multi-page deck is mounted in
//   // the print window.
//   freezeBulkSlideGeometry(sourceDeck, clonedDeck);

//   const sourceFields = sourceDeck.querySelectorAll(
//     "input, textarea, select"
//   );
//   const clonedFields = clonedDeck.querySelectorAll(
//     "input, textarea, select"
//   );

//   sourceFields.forEach((sourceField, index) => {
//     const clonedField = clonedFields[index];

//     if (!clonedField) return;

//     clonedField.value = sourceField.value;

//     if (clonedField.tagName === "TEXTAREA") {
//       clonedField.textContent = sourceField.value;
//     }

//     if (
//       sourceField.type === "checkbox" ||
//       sourceField.type === "radio"
//     ) {
//       clonedField.checked = sourceField.checked;
//     }
//   });

//   // Match PreviewDigitalPPT.handleBrowserPdf(): the normal single-profile
//   // PDF removes editing-only DOM before mounting the print snapshot instead
//   // of merely relying on @media print to hide it. Doing the same here keeps
//   // the Bulk snapshot structurally identical to the standard Preview PDF.
//   clonedDeck
//     .querySelectorAll(
//       '[data-pdp2-print-hide="true"], .pdp2-screen-only'
//     )
//     .forEach((node) => node.remove());

//   clonedDeck
//     .querySelectorAll(".pdp2-print-only")
//     .forEach((node) => {
//       node.style.display = "block";
//     });

//   const printRoot =
//     printWindow.document.getElementById(
//       "pdp2-bulk-print-root"
//     );

//   printRoot.appendChild(clonedDeck);

//   await waitForBulkStyles(printWindow.document);
//   await waitForBulkImages(printWindow.document);

//   if (printWindow.document.fonts?.ready) {
//     try {
//       await printWindow.document.fonts.ready;
//     } catch (error) {
//       console.error(
//         "Could not wait for print fonts:",
//         error
//       );
//     }
//   }
// }


// export default function MSbuttons({
//   project_id,
//   expertIds,
//   clientLogo,
//   setAddLogoPopUp,
//   continueWithoutLogo,
//   setContinueWithoutLogo,
//   project_name,
//   client_name,
//   setEmailDetails,
//   setComposeEmail,
// }) {
//   const urlContextValue = useContext(UrlContext);
//   const { API_URL, URI } = urlContextValue;
//   // const { checkAccessToken } = useContext(UserContext);
//   const { userData } = useContext(UserContext);

//   const [loadingPopup, setLoadingPopup] = useState(false);
//   const [filePath, setFilePath] = useState("");
//   const [showPdfUpload, setShowPdfUpload] = useState(false);
//   const [pdfFile, setPdfFile] = useState(null);
//   const [pdfDragActive, setPdfDragActive] = useState(false);
//   const [pdfUploading, setPdfUploading] = useState(false);
//   const [showBulkPdfSelection, setShowBulkPdfSelection] = useState(false);
//   const [bulkPdfSectionVisibility, setBulkPdfSectionVisibility] = useState(
//     () => ({ ...DEFAULT_BULK_PDF_SECTION_VISIBILITY })
//   );
//   const [bulkPdfIdentityMode, setBulkPdfIdentityMode] = useState("id");

//   const checkForLogo = () => {
//     setAddLogoPopUp(true);
//   };

//   function decodeJwt(token) {
//     try {
//       const base64Url = token.split(".")[1];
//       const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
//       const jsonPayload = decodeURIComponent(
//         atob(base64)
//           .split("")
//           .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
//           .join("")
//       );
//       return JSON.parse(jsonPayload);
//     } catch (err) {
//       console.error("❌ Failed to decode token:", err);
//       return null;
//     }
//   }

//   const handleBulkInmailConnect = async (type) => {
//     setLoadingPopup(true);
//     let url;
//     let connectionType;

//     if (type === "inmail") {
//       url = `${URI}helper/send-bulk-inmail`;
//       connectionType = "send_bulk_inmail";
//     } else if (type === "connect") {
//       url = `${URI}helper/send-bulk-connect`;
//       connectionType = "send_bulk_connect";
//     } else {
//       setLoadingPopup(false);
//       return;
//     }

//     const consulData = {
//       expert_id: expertIds,
//       project_id,
//       project_name,
//     };
//     const ephToken = localStorage.getItem("eph-token");
//     const token = JSON.parse(ephToken).value;

//     const decodedToken = decodeJwt(token);

//     try {
//       const result = await ensureConnectionAndExecute(
//         connectionType,
//         async () => {
//           const response = await fetch(url, {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json",
//               "x-access-token": token,
//             },
//             body: JSON.stringify({
//               token: decodedToken?.preferred_username,
//               expertData: consulData,
//             }),
//           });

//           if (!response.ok) {
//             throw new Error(`HTTP error! status: ${response.status}`);
//           }

//           return await response.json();
//         }
//       );

//       if (!result) {
//         throw new Error("No response received from server");
//       }

//       const actionLabel = type === "inmail" ? "InMail" : "Connect";
//       const estimateTimeout = Math.max(
//         60000,
//         (result.total || expertIds.length || 1) * 20000
//       );

//       if (result.status === "exception") {
//         Swal.fire({
//           icon: "info",
//           title: "Error!",
//           text: "Something went wrong!",
//         });
//         return;
//       }

//       if (result.status === "error") {
//         if (result.message === "User not connected") {
//           Swal.fire({
//             icon: "error",
//             title: "User not connected!",
//             text: "Please refresh the page and update the project list on the extension!",
//           });
//         } else {
//           Swal.fire({
//             icon: "error",
//             title: "Oops...",
//             text: result.message || "Something went wrong!",
//           });
//         }
//         return;
//       }

//       if (result.status === "queued") {
//         const finalState = await pollTaskStatus(URI, result.task_id, token, {
//           timeoutMs: estimateTimeout,
//           intervalMs: 4000,
//         });

//         if (finalState.status === "success") {
//           Swal.fire({
//             icon: "success",
//             title: "Success",
//             text: `${actionLabel} task completed successfully!`,
//           });
//         } else if (finalState.status === "timeout") {
//           Swal.fire({
//             icon: "warning",
//             title: "Timeout",
//             text: "The extension did not confirm completion in time. Please verify in the extension and try again.",
//           });
//         } else {
//           Swal.fire({
//             icon: "error",
//             title: `${actionLabel} failed`,
//             text: finalState.error || `The extension reported an error while processing the ${actionLabel.toLowerCase()} task.`,
//           });
//         }
//         return;
//       }

//       if (result.status === "success") {
//         Swal.fire({
//           icon: "success",
//           title: "Success",
//           text: `${actionLabel} task completed successfully!`,
//         });
//         return;
//       }

//       Swal.fire({
//         icon: "warning",
//         title: "Unexpected response",
//         text: "Received an unexpected status from the server.",
//       });
//     } catch (error) {
//       console.error("❌ Error while handling bulk task:", error);
//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: error.message || "Something went wrong!",
//       });
//     } finally {
//       setLoadingPopup(false);
//     }
//   };

//   const bulkEmailHandler = (type) => {
//     setLoadingPopup(true);
//     const consulData = {
//       expert_id: expertIds,
//       project_id,
//       project_name,
//     };
//     {
//       const tokenObj = localStorage.getItem("eph-token");
//       const token = JSON.parse(tokenObj).value;
//       let url;
//       if (type === "email") {
//         url = `${API_URL}send-bulk-email`;
//       } else if (type === "followUp") {
//         url = `${API_URL}send-bulk-followUp-email`;
//       }
//       fetch(url, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           "x-access-token": token,
//         },
//         body: JSON.stringify(consulData),
//       })
//         .then((res) => res.json())
//         .then((data) => {
//           setLoadingPopup(false);
//           if (data.status === "success") {
//             setEmailDetails(data.emailDetails);
//             setComposeEmail(true);
//           } else {
//             Swal.fire({
//               icon: "error",
//               title: "Oops...",
//               text: "Something went wrong!",
//             });
//           }
//         });
//     }
//   };

//   const fileCreationHandler = async (format) => {
//     const fileLabel =
//       FILE_FORMAT_LABELS[format] || "File";

//     Swal.fire({
//       title: `Generating ${fileLabel}`,
//       text: "Please wait while the file is being prepared...",
//       allowOutsideClick: false,
//       allowEscapeKey: false,
//       showConfirmButton: false,
//       didOpen: () => {
//         Swal.showLoading();
//       },
//     });

//     try {
//       const authToken =
//         localStorage.getItem("accesstoken");
//       const tokenObj =
//         localStorage.getItem("eph-token");
//       const token = JSON.parse(tokenObj).value;

//       const response = await fetch(
//         `${API_URL}create-full-${format}/`,
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//             "x-access-token": token,
//           },
//           body: JSON.stringify({
//             expertIds,
//             project_id,
//             authToken,
//           }),
//         }
//       );

//       const data = await response.json();

//       if (
//         !response.ok ||
//         data.status !== "success"
//       ) {
//         throw new Error(
//           data.message ||
//             `Failed to generate ${fileLabel}.`
//         );
//       }

//       setFilePath(data.filePath);

//       window.open(
//         data.filePath,
//         "_blank",
//         "rel=noopener noreferrer"
//       );

//       await Swal.fire({
//         icon: "success",
//         title: `${fileLabel} ready`,
//         text: `The generated ${fileLabel} file has been opened in a new tab.`,
//         timer: 1800,
//         showConfirmButton: false,
//       });
//     } catch (error) {
//       console.error(
//         `Error generating ${fileLabel}:`,
//         error
//       );

//       Swal.fire({
//         icon: "error",
//         title: `${fileLabel} generation failed`,
//         text:
//           error.message ||
//           `Failed to generate ${fileLabel}.`,
//       });
//     }
//   };

//   const createWordHandler = () => {
//     fileCreationHandler("word");
//   };

//   const createExcelHandler = () => {
//     fileCreationHandler("excel");
//   };

//   const createPPTHandler = () => {
//     if (clientLogo || continueWithoutLogo) {
//       fileCreationHandler("ppt");
//     } else {
//       checkForLogo();
//     }
//   };

//   const toggleBulkPdfSection = (key) => {
//     setBulkPdfSectionVisibility((previous) => ({
//       ...previous,
//       [key]: !previous[key],
//     }));
//   };

//   const handleBulkPdfIdentitySelection = (mode) => {
//     const isAlreadyActive =
//       bulkPdfSectionVisibility.identity && bulkPdfIdentityMode === mode;

//     if (isAlreadyActive) {
//       setBulkPdfIdentityMode(null);
//       setBulkPdfSectionVisibility((previous) => ({
//         ...previous,
//         identity: false,
//       }));
//       return;
//     }

//     setBulkPdfIdentityMode(mode);
//     setBulkPdfSectionVisibility((previous) => ({
//       ...previous,
//       identity: true,
//     }));
//   };

//   const openBulkPdfSelection = () => {
//     if (!Array.isArray(expertIds) || expertIds.length === 0) {
//       Swal.fire({
//         icon: "warning",
//         title: "No profiles selected",
//         text: "Please select at least one digital profile first.",
//       });
//       return;
//     }

//     setShowBulkPdfSelection(true);
//   };

//   const selectPdfFile = (file) => {
//     if (!file) return;

//     const isPdf =
//       file.type === "application/pdf" ||
//       file.name?.toLowerCase().endsWith(".pdf");

//     if (!isPdf) {
//       Swal.fire({
//         icon: "warning",
//         title: "PDF required",
//         text: "Please select a PDF file.",
//       });
//       return;
//     }

//     setPdfFile(file);
//   };

//   const handlePdfDrop = (event) => {
//     event.preventDefault();
//     event.stopPropagation();
//     setPdfDragActive(false);

//     if (pdfUploading) return;

//     const files = Array.from(event.dataTransfer.files || []);

//     if (files.length > 1) {
//       Swal.fire({
//         icon: "warning",
//         title: "One PDF at a time",
//         text: "Please upload only one PDF file.",
//       });
//       return;
//     }

//     selectPdfFile(files[0]);
//   };

//   const closePdfUpload = () => {
//     if (pdfUploading) return;

//     setShowPdfUpload(false);
//     setPdfFile(null);
//     setPdfDragActive(false);
//   };

//   const uploadPdfToSharePoint = async () => {
//     if (!pdfFile) {
//       Swal.fire({
//         icon: "warning",
//         title: "No PDF selected",
//         text: "Please select or drop the PDF file first.",
//       });
//       return;
//     }

//     const authToken = localStorage.getItem("accesstoken");
//     const formData = new FormData();

//     formData.append("file", pdfFile);
//     formData.append("fileName", pdfFile.name);
//     formData.append("authToken", authToken || "");
//     formData.append("projectID", String(project_id));

//     try {
//       setPdfUploading(true);

//       const response = await fetch(
//         `${API_URL}upload-file-to-sharePoint`,
//         {
//           method: "POST",
//           body: formData,
//         }
//       );

//       const data = await response.json();

//       if (
//         !response.ok ||
//         data.status !== "success"
//       ) {
//         throw new Error(
//           data.text ||
//             data.message ||
//             "Failed to upload PDF to SharePoint."
//         );
//       }

//       setShowPdfUpload(false);
//       setPdfFile(null);
//       setPdfDragActive(false);

//       Swal.fire({
//         icon: "success",
//         title: "PDF uploaded",
//         text: "The PDF has been uploaded to SharePoint.",
//       });
//     } catch (error) {
//       console.error(
//         "Error uploading PDF to SharePoint:",
//         error
//       );

//       Swal.fire({
//         icon: "error",
//         title: "Upload failed",
//         text:
//           error.message ||
//           "Failed to upload the PDF to SharePoint.",
//       });
//     } finally {
//       setPdfUploading(false);
//     }
//   };

//   const createBulkPdfHandler = async (pdfSelection) => {
//     if (!Array.isArray(expertIds) || expertIds.length === 0) {
//       Swal.fire({
//         icon: "warning",
//         title: "No profiles selected",
//         text: "Please select at least one digital profile first.",
//       });
//       return;
//     }

//     const selectedSectionVisibility = {
//       ...DEFAULT_BULK_PDF_SECTION_VISIBILITY,
//       ...(pdfSelection?.sectionVisibility || {}),
//     };
//     const selectedIdentityMode = selectedSectionVisibility.identity
//       ? pdfSelection?.identityMode || "id"
//       : null;

//     Swal.fire({
//       title: "Generating bulk PDF",
//       text: `Preparing ${expertIds.length} digital profile${
//         expertIds.length === 1 ? "" : "s"
//       }...`,
//       allowOutsideClick: false,
//       allowEscapeKey: false,
//       showConfirmButton: false,
//       didOpen: () => {
//         Swal.showLoading();
//       },
//     });

//     let renderHost = null;
//     let renderRoot = null;

//     try {
//       const tokenObj =
//         localStorage.getItem("eph-token");
//       const token = tokenObj
//         ? JSON.parse(tokenObj).value
//         : null;

//       /*
//        * 1. Fetch everything first while the parent page remains active.
//        */
//       const response = await fetch(
//         `${API_URL}fetch-digital-profiles-for-pdf`,
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//             ...(token
//               ? { "x-access-token": token }
//               : {}),
//           },
//           body: JSON.stringify({
//             projectID: project_id,
//             expertIDs: expertIds,
//             sectionVisibility: selectedSectionVisibility,
//             identityMode: selectedIdentityMode,
//           }),
//         }
//       );

//       const data = await response.json();

//       if (
//         !response.ok ||
//         data.status !== "success"
//       ) {
//         throw new Error(
//           data.text ||
//             data.message ||
//             "Failed to fetch digital profiles."
//         );
//       }

//       const profiles = Array.isArray(
//         data.powerpointData
//       )
//         ? data.powerpointData
//         : [];

//       if (!profiles.length) {
//         throw new Error(
//           "No digital profiles were returned."
//         );
//       }

//       /*
//        * 2. Render the full read-only PDF deck in the CURRENT page first.
//        *
//        * The previous implementation opened the new tab before this step.
//        * Browsers pause/throttle requestAnimationFrame in a background tab,
//        * which meant this parent-page render could remain suspended until
//        * the user returned to the parent tab.
//        *
//        * flushSync commits the hidden deck immediately while this tab is
//        * active, so there is no background-tab dependency.
//        */
//       renderHost = document.createElement("div");
//       renderHost.setAttribute(
//         "data-pdp2-bulk-render-host",
//         "true"
//       );

//       Object.assign(renderHost.style, {
//         position: "fixed",
//         left: "-100000px",
//         top: "0",
//         width: "1280px",
//         visibility: "hidden",
//         pointerEvents: "none",
//         zIndex: "-1",
//       });

//       document.body.appendChild(renderHost);

//       renderRoot = createRoot(renderHost);

//       flushSync(() => {
//         renderRoot.render(
//           <UrlContext.Provider value={urlContextValue}>
//             <BulkDigitalProfileDeck
//               profiles={profiles}
//               projectName={project_name}
//               clientName={client_name}
//               contactName={userData?.fullname || ""}
//               contactEmail={userData?.email || ""}
//               projectType={profiles?.[0]?.projectType}
//               sectionVisibility={selectedSectionVisibility}
//               identityMode={selectedIdentityMode}
//             />
//           </UrlContext.Provider>
//         );
//       });

//       // Let shared-slide effects (notably Education auto-sizing) commit before
//       // cloning the rendered deck into the print window.
//       await new Promise((resolve) => {
//         requestAnimationFrame(() => requestAnimationFrame(resolve));
//       });

//       await waitForBulkImages(renderHost);

//       if (document.fonts?.ready) {
//         try {
//           await document.fonts.ready;
//         } catch (error) {
//           console.error(
//             "Could not wait for PDF fonts:",
//             error
//           );
//         }
//       }

//       const makeSafePdfFilePart = (value, fallback) => {
//         const cleaned = String(value || fallback || "")
//           .replace(/[\\/:*?"<>|]+/g, " ")
//           .replace(/\s+/g, " ")
//           .trim();

//         return cleaned;
//       };

//       const now = new Date();
//       const dateMonthYear = `${String(now.getDate()).padStart(2, "0")}${new Intl.DateTimeFormat(
//         "en-US",
//         { month: "short" }
//       ).format(now)}${String(now.getFullYear()).slice(-2)}`;

//       const bulkPdfFileName = `expertpowerhouse_${makeSafePdfFilePart(
//         client_name,
//         "Client"
//       )}_${makeSafePdfFilePart(
//         project_name,
//         "Project"
//       )}_${dateMonthYear}`;

//       /*
//        * 3. At this point the backend data, React deck and images are ready.
//        *
//        * Ask for one explicit click before opening the print window.
//        * This prevents browser popup blockers from rejecting window.open()
//        * after the asynchronous fetch/render work.
//        */
//       const readyResult = await Swal.fire({
//         icon: "success",
//         title: "Bulk PDF ready",
//         text: `${profiles.length} digital profile${
//           profiles.length === 1 ? "" : "s"
//         } prepared and ready to print.`,
//         confirmButtonText: "Open PDF",
//         showCancelButton: true,
//         cancelButtonText: "Cancel",
//         reverseButtons: true,
//       });

//       if (!readyResult.isConfirmed) {
//         renderRoot.unmount();
//         renderRoot = null;

//         renderHost.remove();
//         renderHost = null;

//         return;
//       }

//       /*
//        * 4. Only now open the new window.
//        * This click is a direct user action, so popup blockers should allow it.
//        */
//       const printWindow = window.open(
//         "",
//         "_blank",
//         "width=1400,height=900"
//       );

//       if (!printWindow) {
//         throw new Error(
//           "The PDF window was blocked. Please allow popups for this site and try again."
//         );
//       }

//       Swal.fire({
//         title: "Opening PDF",
//         text: "Preparing the print window...",
//         allowOutsideClick: false,
//         allowEscapeKey: false,
//         showConfirmButton: false,
//         didOpen: () => {
//           Swal.showLoading();
//         },
//       });

//       try {
//         await prepareBulkPdfPrintWindow(
//           printWindow,
//           renderHost,
//           bulkPdfFileName
//         );

//         renderRoot.unmount();
//         renderRoot = null;

//         renderHost.remove();
//         renderHost = null;

//         Swal.close();

//         printWindow.onafterprint = () => {
//           setPdfFile(null);
//           setPdfDragActive(false);
//           setShowPdfUpload(true);

//           try {
//             printWindow.close();
//           } catch (error) {
//             console.error(
//               "Could not close bulk PDF window:",
//               error
//             );
//           }
//         };

//         setTimeout(() => {
//           printWindow.focus();
//           printWindow.print();
//         }, 250);
//       } catch (printError) {
//         try {
//           printWindow.close();
//         } catch (closeError) {
//           console.error(
//             "Could not close failed bulk PDF window:",
//             closeError
//           );
//         }

//         throw printError;
//       }
//     } catch (error) {
//       console.error(
//         "Error generating bulk digital profile PDF:",
//         error
//       );

//       if (renderRoot) {
//         renderRoot.unmount();
//       }

//       if (renderHost?.isConnected) {
//         renderHost.remove();
//       }

//       Swal.fire({
//         icon: "error",
//         title: "Bulk PDF generation failed",
//         text:
//           error.message ||
//           "Failed to generate the bulk PDF.",
//       });
//     }
//   };


//   useEffect(() => {
//     if (continueWithoutLogo) {
//       createPPTHandler();
//       setContinueWithoutLogo(false);
//       setAddLogoPopUp(false);
//     }
//   }, [continueWithoutLogo]);

//   return (
//     <>
//       <div className="dropdown">
//         <button
//           className="btn dropdown-toggle"
//           type="button"
//           id="fileGenerationDropdownButton"
//           data-toggle="dropdown"
//           aria-haspopup="true"
//           aria-expanded="false"
//         >
//           Files
//         </button>

//         <div
//           className="dropdown-menu"
//           aria-labelledby="fileGenerationDropdownButton"
//           style={{
//             width: "200px",
//           }}
//         >
//           <button
//             className="btn"
//             style={{
//               width: "100%",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               gap: "10px",
//               textAlign: "center",
//             }}
//             onClick={createWordHandler}
//           >
//             <FileText size={16} strokeWidth={1.9} />
//             <span>Word</span>
//           </button>

//           <button
//             className="btn"
//             style={{
//               width: "100%",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               gap: "10px",
//               textAlign: "center",
//             }}
//             onClick={createPPTHandler}
//           >
//             <Presentation size={16} strokeWidth={1.9} />
//             <span>PPTX</span>
//           </button>

//           <button
//             className="btn"
//             style={{
//               width: "100%",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               gap: "10px",
//               textAlign: "center",
//             }}
//             onClick={createExcelHandler}
//           >
//             <FileSpreadsheet size={16} strokeWidth={1.9} />
//             <span>Excel</span>
//           </button>

//           <button
//             className="btn"
//             style={{
//               width: "100%",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               gap: "10px",
//               textAlign: "center",
//             }}
//             onClick={openBulkPdfSelection}
//           >
//             <FileDown size={16} strokeWidth={1.9} />
//             <span>Bulk PDF</span>
//           </button>
//         </div>
//       </div>

//       <div className="dropdown">
//         <button
//           className="btn dropdown-toggle"
//           type="button"
//           id="dropdownMenuButton"
//           data-toggle="dropdown"
//           aria-haspopup="true"
//           aria-expanded="false"
//           // style={{ marginBottom: "10px" }}
//         >
//           Contact
//         </button>

//         <div
//           className="dropdown-menu"
//           aria-labelledby="dropdownMenuButton"
//           style={{ width: "200px", textAlign: "center" }}
//         >
//           <button
//             className="btn"
//             style={{ width: "100%" }}
//             onClick={() => bulkEmailHandler("email")}
//           >
//             First outreach email
//           </button>
//           <button
//             className="btn"
//             style={{ width: "100%" }}
//             onClick={() => bulkEmailHandler("followUp")}
//           >
//             Follow-up email
//           </button>
//           <button
//             className="btn"
//             style={{ width: "100%" }}
//             onClick={() => handleBulkInmailConnect("inmail")}
//           >
//             Inmail
//           </button>
//           <button
//             className="btn"
//             style={{ width: "100%" }}
//             onClick={() => handleBulkInmailConnect("connect")}
//           >
//             Connect
//           </button>
//         </div>
//       </div>

//       <BulkPdfSectionSelectionModal
//         open={showBulkPdfSelection}
//         sectionVisibility={bulkPdfSectionVisibility}
//         identityMode={bulkPdfIdentityMode}
//         onToggleSection={toggleBulkPdfSection}
//         onIdentitySelection={handleBulkPdfIdentitySelection}
//         onClose={() => setShowBulkPdfSelection(false)}
//         onConfirm={() => {
//           const selection = {
//             sectionVisibility: { ...bulkPdfSectionVisibility },
//             identityMode: bulkPdfSectionVisibility.identity
//               ? bulkPdfIdentityMode || "id"
//               : null,
//           };

//           flushSync(() => {
//             setShowBulkPdfSelection(false);
//           });

//           createBulkPdfHandler(selection);
//         }}
//       />

//       {showPdfUpload && (
//         <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40 px-4 backdrop-blur-sm">
//           <div className="w-full max-w-lg overflow-hidden rounded-3xl bg-white shadow-2xl">
//             {/* Header */}
//             <div className="flex items-start justify-between gap-4 border-b border-slate-200 px-6 py-4">
//               <div className="min-w-0">
//                 <h3 className="text-base font-bold text-slate-800">
//                   Upload saved PDF
//                 </h3>

//                 <p className="mt-1 text-xs leading-5 text-slate-500">
//                   If you saved the PDF from the print window, upload it here to
//                   store it in SharePoint.
//                 </p>
//               </div>

//               <button
//                 type="button"
//                 disabled={pdfUploading}
//                 onClick={closePdfUpload}
//                 className="
//                   flex h-8 w-8 shrink-0 items-center justify-center
//                   rounded-full !border-0 !bg-transparent
//                   !p-0 !text-xl !font-normal !leading-none
//                   !text-slate-400
//                   transition
//                   hover:!bg-slate-100 hover:!text-slate-700
//                   disabled:cursor-not-allowed disabled:opacity-40
//                 "
//                 aria-label="Close PDF upload"
//                 title="Close"
//               >
//                 ×
//               </button>
//             </div>

//             {/* Body */}
//             <div className="p-6">
//               <label
//                 onDragEnter={(event) => {
//                   if (pdfUploading) return;

//                   event.preventDefault();
//                   event.stopPropagation();
//                   setPdfDragActive(true);
//                 }}
//                 onDragOver={(event) => {
//                   if (pdfUploading) return;

//                   event.preventDefault();
//                   event.stopPropagation();
//                   setPdfDragActive(true);
//                 }}
//                 onDragLeave={(event) => {
//                   event.preventDefault();
//                   event.stopPropagation();
//                   setPdfDragActive(false);
//                 }}
//                 onDrop={handlePdfDrop}
//                 className={[
//                   "relative flex min-h-[230px] flex-col items-center justify-center",
//                   "rounded-2xl border-2 border-dashed px-6 text-center transition",
//                   pdfUploading
//                     ? "cursor-default border-slate-200 bg-slate-50"
//                     : pdfDragActive
//                       ? "cursor-pointer border-[#365561] bg-[#365561]/5"
//                       : "cursor-pointer border-slate-300 bg-slate-50 hover:border-[#365561]/60 hover:bg-slate-100",
//                 ].join(" ")}
//               >
//                 <input
//                   type="file"
//                   accept=".pdf,application/pdf"
//                   className="hidden"
//                   disabled={pdfUploading}
//                   onChange={(event) => {
//                     const file = event.target.files?.[0];

//                     selectPdfFile(file);

//                     event.target.value = "";
//                   }}
//                 />

//                 {pdfUploading ? (
//                   /* Uploading state */
//                   <div className="flex flex-col items-center justify-center">
//                     <span
//                       className="
//                         h-10 w-10 animate-spin rounded-full
//                         border-[3px] border-slate-200
//                         border-t-[#365561]
//                       "
//                     />

//                     <p className="mt-4 text-sm font-semibold text-slate-700">
//                       Uploading PDF...
//                     </p>

//                     <p className="mt-1 text-xs text-slate-400">
//                       Saving the file to SharePoint
//                     </p>

//                     {pdfFile?.name && (
//                       <p className="mt-4 max-w-[320px] truncate text-xs font-medium text-slate-500">
//                         {pdfFile.name}
//                       </p>
//                     )}
//                   </div>
//                 ) : pdfFile ? (
//                   /* Selected PDF state */
//                   <>
//                     <div className="relative mb-4 flex h-16 w-14 items-center justify-center">
//                       <FileText
//                         size={52}
//                         strokeWidth={1.35}
//                         className="text-[#365561]"
//                       />

//                       <span
//                         className="
//                           absolute -bottom-1 left-1/2
//                           -translate-x-1/2
//                           rounded-md bg-[#365561]
//                           px-1.5 py-0.5
//                           text-[8px] font-bold tracking-wide text-white
//                         "
//                       >
//                         PDF
//                       </span>
//                     </div>

//                     <p className="max-w-full break-all text-sm font-semibold text-slate-700">
//                       {pdfFile.name}
//                     </p>

//                     <p className="mt-1 text-xs text-slate-400">
//                       {(pdfFile.size / 1024 / 1024).toFixed(2)} MB
//                     </p>

//                     <p className="mt-4 text-xs font-semibold text-[#365561]">
//                       Click or drop another PDF to replace it
//                     </p>
//                   </>
//                 ) : (
//                   /* Empty state */
//                   <>
//                     <FileDown
//                       size={36}
//                       strokeWidth={1.5}
//                       className="mb-3 text-[#365561]"
//                     />

//                     <p className="text-sm font-semibold text-slate-700">
//                       Drag &amp; drop your PDF here
//                     </p>

//                     <p className="my-2 text-xs text-slate-400">
//                       or
//                     </p>

//                     <span
//                       className="
//                         rounded-xl bg-[#365561]
//                         px-4 py-2
//                         text-xs font-semibold text-white shadow-sm
//                       "
//                     >
//                       Select from computer
//                     </span>

//                     <p className="mt-4 text-[10px] text-slate-400">
//                       One PDF file at a time
//                     </p>
//                   </>
//                 )}
//               </label>
//             </div>

//             {/* Footer */}
//             <div className="flex justify-end gap-2 border-t border-slate-200 bg-slate-50 px-6 py-3">
//               <button
//                 type="button"
//                 disabled={pdfUploading}
//                 onClick={closePdfUpload}
//                 className="
//                   rounded-xl
//                   !border !border-slate-200
//                   !bg-white
//                   px-4 py-2
//                   !text-sm !font-semibold !text-slate-600
//                   transition
//                   hover:!border-slate-300 hover:!bg-slate-100 hover:!text-slate-700
//                   disabled:cursor-not-allowed disabled:opacity-40
//                 "
//               >
//                 Skip
//               </button>

//               <button
//                 type="button"
//                 disabled={!pdfFile || pdfUploading}
//                 onClick={uploadPdfToSharePoint}
//                 className="
//                   inline-flex min-w-[120px] items-center justify-center gap-2
//                   rounded-xl
//                   !border-0
//                   !bg-[#365561]
//                   px-4 py-2
//                   !text-sm !font-semibold !text-white
//                   transition
//                   hover:!bg-[#2e4a54] hover:!text-white
//                   disabled:cursor-not-allowed
//                   disabled:!bg-slate-300 disabled:!text-white
//                   disabled:opacity-100
//                 "
//               >
//                 {pdfUploading && (
//                   <span
//                     className="
//                       h-4 w-4 animate-spin rounded-full
//                       border-2 border-white/40 border-t-white
//                     "
//                   />
//                 )}

//                 {pdfUploading ? "Uploading..." : "Upload"}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {loadingPopup && (
//         <div className="deletePrj-popup-wrapper">
//           <div className="tab-pane fade show deletePrj-div">
//             <center>
//               <p style={{ fontSize: "18px" }}>Please wait . . .</p>
//               <br />
//               <img
//                 src={LoadingIcon}
//                 alt=""
//                 style={{ width: "50px", marginRight: "5px" }}
//               />
//             </center>
//           </div>
//         </div>
//       )}
//     </>
//   );
// }


import React, { useContext, useEffect, useState } from "react";
import { createPortal, flushSync } from "react-dom";
import { createRoot } from "react-dom/client";
import { AnimatePresence, motion } from "framer-motion";
import {
  BriefcaseBusiness,
  CalendarClock,
  Coins,
  FileDown,
  FileSpreadsheet,
  FileText,
  Globe2,
  GraduationCap,
  Hash,
  ImagePlus,
  Languages,
  MapPin,
  Presentation,
  Target,
  UserRound,
} from "lucide-react";
import Swal from "sweetalert2";
import LoadingIcon from "../../images/Loading_icon.gif";
import bulkPdfFirstPage from "../../images/bulk_pdf_first_page.png";
import bulkPdfLastPage from "../../images/bulk_pdf_last_page.png";
import { UrlContext } from "../../contexts/UrlContext";
import { UserContext } from "../../contexts/UserContext";
import { ensureConnectionAndExecute } from "../../utils/eph-connection-manager";
import { pollTaskStatus } from "../../utils/taskStatus";
import DigitalProfileSlide from "../PreviewDigitalPPT/DigitalProfileSlide";
import "../../styles/previewDigitalPPTBrowser.css";
import "react-quill/dist/quill.snow.css";


const FILE_FORMAT_LABELS = {
  word: "Word",
  ppt: "PPTX",
  excel: "Excel",
};


const DEFAULT_BULK_PDF_SECTION_VISIBILITY = {
  profilePicture: true,
  identity: true,
  position: true,
  location: true,
  region: false,
  language: true,
  totalExperience: true,
  availability: true,
  rate: true,
  summary: true,
  matching: true,
  experience: true,
  education: true,
};

function BulkPdfSectionToggle({
  checked,
  onChange,
  icon: Icon,
  label,
}) {
  return (
    <button
      type="button"
      className={`pdp2-section-option${checked ? " is-active" : ""}`}
      onClick={onChange}
      aria-pressed={checked}
    >
      <span className="pdp2-section-option-icon" aria-hidden="true">
        <Icon size={17} strokeWidth={2} />
      </span>
      <span className="pdp2-section-option-copy">
        <strong>{label}</strong>
      </span>
      <span className="pdp2-section-option-switch" aria-hidden="true">
        <span />
      </span>
    </button>
  );
}

function BulkPdfLivePreview({
  profiles,
  loading,
  error,
  sectionVisibility,
  identityMode,
  projectName,
  clientName,
  contactName,
  contactEmail,
}) {
  if (loading) {
    return (
      <div className="flex h-full min-h-[420px] items-center justify-center rounded-2xl border border-slate-200 bg-white/80">
        <div className="text-center">
          <i className="fa-solid fa-spinner fa-spin text-3xl text-[#365561]" />
          <p className="mt-3 text-sm font-semibold text-slate-600">Loading PDF preview...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex h-full min-h-[420px] items-center justify-center rounded-2xl border border-rose-200 bg-rose-50/70 p-6 text-center">
        <div>
          <p className="text-sm font-semibold text-rose-700">Preview unavailable</p>
          <p className="mt-1 max-w-md text-xs leading-5 text-rose-600">{error}</p>
        </div>
      </div>
    );
  }

  if (!Array.isArray(profiles) || profiles.length === 0) {
    return (
      <div className="flex h-full min-h-[420px] items-center justify-center rounded-2xl border border-slate-200 bg-white/80 p-6 text-center">
        <p className="text-sm text-slate-500">Select at least one profile to load a preview.</p>
      </div>
    );
  }

  const previewScale = 0.62;
  const pageCount = profiles.length + 2;
  const pageGap = 18;
  const unscaledDeckHeight = pageCount * 720 + Math.max(pageCount - 1, 0) * pageGap;

  return (
    <div className="flex h-full min-h-0 flex-col overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-[0_10px_34px_rgba(15,23,42,0.08)]">
      <div className="flex shrink-0 items-start justify-between gap-4 border-b border-slate-200 px-4 py-3">
        <div>
          <p className="text-sm font-bold text-slate-800">Full PDF preview</p>
          <p className="mt-0.5 text-xs text-slate-500">
            Scroll through the cover, all selected profiles, and the closing page. Changes on the left are reflected immediately.
          </p>
        </div>
        <span className="shrink-0 rounded-full bg-[#365561]/10 px-2.5 py-1 text-[10px] font-bold text-[#365561]">
          {pageCount} pages
        </span>
      </div>

      <div className="bulk-pdf-live-preview min-h-0 flex-1 overflow-auto bg-slate-100/80 p-4">
        <style>{`
          .bulk-pdf-live-preview .pdp2-page-shell.pdp2-bulk-pdf-deck {
            width: 1280px !important;
            min-height: 0 !important;
            margin: 0 !important;
            padding: 0 !important;
            display: flex !important;
            flex-direction: column !important;
            gap: ${pageGap}px !important;
            overflow: visible !important;
            background: transparent !important;
          }

          .bulk-pdf-live-preview .pdp2-bulk-pdf-deck > .pdp2-slide,
          .bulk-pdf-live-preview .pdp2-bulk-pdf-deck > [data-pdp2-bulk-static-page] {
            flex: 0 0 720px !important;
            width: 1280px !important;
            height: 720px !important;
            margin: 0 !important;
            box-shadow: 0 12px 34px rgba(15, 23, 42, 0.14) !important;
          }
        `}</style>

        <div
          className="mx-auto"
          style={{
            width: `${1280 * previewScale}px`,
            height: `${unscaledDeckHeight * previewScale}px`,
          }}
        >
          <div
            style={{
              width: "1280px",
              height: `${unscaledDeckHeight}px`,
              transform: `scale(${previewScale})`,
              transformOrigin: "top left",
            }}
          >
            <BulkDigitalProfileDeck
              profiles={profiles}
              projectName={projectName}
              clientName={clientName}
              contactName={contactName}
              contactEmail={contactEmail}
              projectType={profiles?.[0]?.projectType}
              sectionVisibility={sectionVisibility}
              identityMode={identityMode}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

function BulkPdfSectionSelectionModal({
  open,
  sectionVisibility,
  identityMode,
  previewProfiles,
  previewLoading,
  previewError,
  projectName,
  clientName,
  contactName,
  contactEmail,
  onToggleSection,
  onIdentitySelection,
  onClose,
  onConfirm,
}) {
  if (typeof document === "undefined") return null;

  const informationOptions = [
    { key: "profilePicture", label: "Profile picture", description: "Consultant profile photo", icon: ImagePlus, checked: sectionVisibility.profilePicture, onChange: () => onToggleSection("profilePicture") },
    { key: "ephId", label: "EPH ID", description: "EPH_CON_ / EPH_EXP_ identifier", icon: Hash, checked: sectionVisibility.identity && identityMode === "id", onChange: () => onIdentitySelection("id") },
    { key: "name", label: "Name", description: "Consultant name", icon: UserRound, checked: sectionVisibility.identity && identityMode === "name", onChange: () => onIdentitySelection("name") },
    { key: "position", label: "Position", description: "Current role or headline", icon: BriefcaseBusiness, checked: sectionVisibility.position, onChange: () => onToggleSection("position") },
    { key: "location", label: "Location", description: "Current consultant location", icon: MapPin, checked: sectionVisibility.location, onChange: () => onToggleSection("location") },
    { key: "region", label: "Region", description: "Regional experience", icon: Globe2, checked: sectionVisibility.region, onChange: () => onToggleSection("region") },
    { key: "language", label: "Languages", description: "Language capabilities", icon: Languages, checked: sectionVisibility.language, onChange: () => onToggleSection("language") },
    { key: "totalExperience", label: "Total experience", description: "Years of professional experience", icon: BriefcaseBusiness, checked: sectionVisibility.totalExperience, onChange: () => onToggleSection("totalExperience") },
    { key: "availability", label: "Availability", description: "Current availability note", icon: CalendarClock, checked: sectionVisibility.availability, onChange: () => onToggleSection("availability") },
    { key: "rate", label: "Rate", description: "Currency, rate and billing unit", icon: Coins, checked: sectionVisibility.rate, onChange: () => onToggleSection("rate") },
  ];

  const contentOptions = [
    { key: "summary", label: "Professional Summary", description: "Main consultant summary", icon: FileText, checked: sectionVisibility.summary, onChange: () => onToggleSection("summary") },
    { key: "matching", label: "Requirement Matching", description: "Dimensions and radar matching", icon: Target, checked: sectionVisibility.matching, onChange: () => onToggleSection("matching") },
    { key: "experience", label: "Relevant Experience", description: "Selected professional experience", icon: BriefcaseBusiness, checked: sectionVisibility.experience, onChange: () => onToggleSection("experience") },
    { key: "education", label: "Education & Certification", description: "Education and credentials", icon: GraduationCap, checked: sectionVisibility.education, onChange: () => onToggleSection("education") },
  ];

  const informationActiveCount = informationOptions.filter((option) => option.checked).length;
  const contentActiveCount = contentOptions.filter((option) => option.checked).length;

  return createPortal(
    <AnimatePresence>
      {open && (
        <motion.div
          className="fixed inset-0 z-[10050] flex items-center justify-center bg-slate-950/45 p-4 backdrop-blur-sm sm:p-6"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.16 }}
          role="presentation"
          data-pdp2-print-hide="true"
          onMouseDown={(event) => {
            if (event.target === event.currentTarget) onClose();
          }}
        >
          <motion.div
            className="pdp2-section-picker flex h-[94vh] max-h-[94vh] w-[min(900px,calc(100vw-24px))] flex-col overflow-hidden rounded-[26px] border border-slate-200/90 bg-[radial-gradient(circle_at_top,rgba(54,85,97,0.14),transparent_34%),linear-gradient(to_bottom,#f8fafc,#eef2f6)] shadow-[0_28px_90px_rgba(15,23,42,0.34)] lg:w-[min(1720px,calc(100vw-24px))]"
            initial={{ opacity: 0, y: 22, scale: 0.975 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 18, scale: 0.98 }}
            transition={{ type: "spring", stiffness: 340, damping: 30, mass: 0.82 }}
            role="dialog"
            aria-modal="true"
            aria-labelledby="bulk-pdf-section-picker-title"
            onMouseDown={(event) => event.stopPropagation()}
          >
            <div className="pdp2-section-picker-header">
              <div className="pdp2-section-picker-title-wrap">
                <span className="pdp2-section-picker-eyebrow">Bulk PDF layout</span>
                <strong id="bulk-pdf-section-picker-title">Choose visible sections</strong>
                <p>Choose which information and content blocks should appear on every selected digital profile in this PDF. This selection is used only for the PDF and is not saved to the profile.</p>
              </div>
              <button type="button" className="pdp2-section-picker-close" onClick={onClose} aria-label="Close bulk PDF section picker">×</button>
            </div>

            <div className="pdp2-section-picker-body min-h-0 overflow-hidden" style={{ overflow: "hidden" }}>
              <div
                className="grid h-full min-h-0 grid-cols-1 gap-4 p-3 sm:p-4 lg:grid-cols-[minmax(420px,620px)_minmax(0,1fr)] xl:grid-cols-[720px_minmax(0,1fr)]"
                style={{ gridTemplateRows: "minmax(0, 1fr)" }}
              >
                <div className="h-full min-h-0 space-y-4 overflow-y-auto overscroll-contain pr-2">
                  <section className="pdp2-section-picker-panel pdp2-section-picker-panel-information">
                    <div className="pdp2-section-picker-panel-header">
                      <div className="pdp2-section-picker-panel-title">
                        <span className="pdp2-section-picker-panel-icon"><UserRound size={17} strokeWidth={2} /></span>
                        <div><strong>Information</strong></div>
                      </div>
                      <span className="pdp2-section-picker-count">{informationActiveCount}/{informationOptions.length}</span>
                    </div>
                    <div className="pdp2-section-picker-grid grid-cols-1 sm:grid-cols-2">
                      {informationOptions.map((option) => (
                        <BulkPdfSectionToggle
                          key={option.key}
                          checked={option.checked}
                          onChange={option.onChange}
                          icon={option.icon}
                          label={option.label}
                        />
                      ))}
                    </div>
                    <div className="pdp2-section-picker-note">
                      <Hash size={13} strokeWidth={2} />
                      <span><strong>EPH ID</strong> and <strong>Name</strong> share the same profile area and are mutually exclusive.</span>
                    </div>
                  </section>

                  <section className="pdp2-section-picker-panel pdp2-section-picker-panel-content">
                    <div className="pdp2-section-picker-panel-header">
                      <div className="pdp2-section-picker-panel-title">
                        <span className="pdp2-section-picker-panel-icon"><FileText size={17} strokeWidth={2} /></span>
                        <div><strong>Content</strong></div>
                      </div>
                      <span className="pdp2-section-picker-count">{contentActiveCount}/{contentOptions.length}</span>
                    </div>
                    <div className="pdp2-section-picker-grid grid-cols-1 sm:grid-cols-2">
                      {contentOptions.map((option) => (
                        <BulkPdfSectionToggle
                          key={option.key}
                          checked={option.checked}
                          onChange={option.onChange}
                          icon={option.icon}
                          label={option.label}
                        />
                      ))}
                    </div>
                  </section>
                </div>

                <div className="hidden min-h-0 lg:block">
                  <BulkPdfLivePreview
                    profiles={previewProfiles}
                    loading={previewLoading}
                    error={previewError}
                    sectionVisibility={sectionVisibility}
                    identityMode={sectionVisibility.identity ? identityMode || "id" : null}
                    projectName={projectName}
                    clientName={clientName}
                    contactName={contactName}
                    contactEmail={contactEmail}
                  />
                </div>
              </div>
            </div>

            <div className="flex shrink-0 items-center justify-end gap-2 border-t border-slate-200/90 bg-white/85 px-5 py-4 backdrop-blur-sm">
              <button type="button" className="rounded-xl border border-slate-200 bg-white px-4 py-2 text-sm font-semibold text-slate-600 transition hover:bg-slate-50 focus:outline-none" onClick={onClose}>Cancel</button>
              <button type="button" className="rounded-xl border-0 bg-[#365561] px-5 py-2 text-sm font-semibold text-white transition hover:bg-[#2e4a54] focus:outline-none" onClick={onConfirm}>Generate PDF</button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>,
    document.body
  );
}

function BulkPdfCoverPage({
  projectName,
  clientName,
  projectType,
}) {
  const monthYear = new Intl.DateTimeFormat("en-US", {
    month: "long",
    year: "numeric",
  })
    .format(new Date())
    .toUpperCase();

  const deckTitle =
    projectType === "exp"
      ? "Selected Expert Profiles"
      : "Selected Consulting Profiles";

  return (
    <div
      className="pdp2-bulk-print-page relative h-[720px] w-[1280px] shrink-0 overflow-hidden bg-white"
      data-pdp2-bulk-static-page="cover"
    >
      {/*
        Use a real <img> rather than CSS background-image so the first
        page is always included by the browser print engine even when
        "Background graphics" is disabled.
      */}
      <img
        src={bulkPdfFirstPage}
        alt=""
        aria-hidden="true"
        className="absolute inset-0 h-full w-full select-none object-fill"
        draggable="false"
      />

      <div
        className="absolute text-white"
        style={{
          left: "10.2%",
          top: "62.0%",
          width: "64%",
          fontFamily: "Arial, Helvetica, sans-serif",
        }}
      >
        <div
          style={{
            fontSize: "32px",
            lineHeight: 1.12,
            fontWeight: 700,
            letterSpacing: "-0.4px",
          }}
        >
          {deckTitle}
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            gap: "0px",
            marginTop: "17px",
            fontSize: "23px",
            lineHeight: 1.18,
            fontWeight: 400,
            width: "100%",
          }}
        >
          <span
            className="shrink-0"
            style={{ minWidth: "66px" }}
          >
            Topic:
          </span>

          <span
            style={{
              display: "block",
              width: "50ch",
              maxWidth: "50ch",
              flex: "0 0 50ch",
              fontWeight: 400,
              whiteSpace: "normal",
              overflowWrap: "break-word",
              wordBreak: "normal",
            }}
          >
            {projectName || ""}
          </span>
        </div>
      </div>

      <div
        className="absolute text-white"
        style={{
          left: "10.2%",
          top: "82.4%",
          width: "64%",
          fontFamily: "Arial, Helvetica, sans-serif",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "baseline",
            gap: "6px",
            fontSize: "20px",
            lineHeight: 1.2,
            whiteSpace: "nowrap",
          }}
        >
          <span style={{ fontWeight: 700 }}>
            Prepared for
          </span>
          <span
            style={{
              fontWeight: 600,
              minWidth: 0,
              whiteSpace: "nowrap",
            }}
          >
            {clientName || ""}
          </span>
        </div>
      </div>

      <div
        className="absolute text-[#365561]"
        style={{
          left: "10.2%",
          top: "93.5%",
          width: "50%",
          fontFamily: "Arial, Helvetica, sans-serif",
          fontSize: "17px",
          lineHeight: 1.2,
          fontWeight: 700,
        }}
      >
        {monthYear}
      </div>
    </div>
  );
}

function BulkPdfLastPage({
  contactName,
  contactEmail,
}) {
  return (
    <div
      className="pdp2-bulk-print-page relative h-[720px] w-[1280px] shrink-0 overflow-hidden bg-[#365561]"
      data-pdp2-bulk-static-page="outro"
    >
      <img
        src={bulkPdfLastPage}
        alt=""
        aria-hidden="true"
        className="absolute inset-0 h-full w-full select-none object-fill"
        draggable="false"
      />

      <div
        className="absolute text-white"
        style={{
          left: "60.7%",
          top: "4.0%",
          width: "34.5%",
          fontFamily: "Arial, Helvetica, sans-serif",
        }}
      >
        <div
          style={{
            fontSize: "28px",
            lineHeight: 1.24,
            fontWeight: 700,
            letterSpacing: "-0.35px",
          }}
        >
          Let us find the right expertise
          <br />
          for your project
        </div>

        <div
          style={{
            marginTop: "31px",
            fontSize: "17px",
            lineHeight: 1.25,
            fontWeight: 400,
          }}
        >
          Reach out to your Contact
        </div>

        <div
          style={{
            marginTop: "6px",
            fontSize: "17px",
            lineHeight: 1.28,
            fontWeight: 600,
            overflowWrap: "anywhere",
          }}
        >
          {contactName || ""}
        </div>

        <div
          style={{
            marginTop: "1px",
            fontSize: "17px",
            lineHeight: 1.28,
            fontWeight: 600,
            overflowWrap: "anywhere",
          }}
        >
          {contactEmail || ""}
        </div>

        <div
          style={{
            marginTop: "66px",
            fontSize: "17px",
            lineHeight: 1.2,
            fontWeight: 700,
          }}
        >
          Cologne | Düsseldorf | Mumbai
        </div>
      </div>
    </div>
  );
}

function BulkDigitalProfileDeck({
  profiles,
  projectName,
  clientName,
  contactName,
  contactEmail,
  projectType,
  sectionVisibility,
  identityMode,
}) {
  return (
    <div className="pdp2-page-shell pdp2-bulk-pdf-deck">
      <BulkPdfCoverPage
        projectName={projectName}
        clientName={clientName}
        projectType={projectType}
      />

      {profiles.map((profile, index) => (
        <DigitalProfileSlide
          key={profile?.ID || profile?.expertID || index}
          readOnly
          previewPrintLayout
          showProposedRates={false}
          sectionVisibility={sectionVisibility}
          expertID={profile?.expertID || profile?.ID}
          powerPointID={
            profile?.powerPointID ||
            profile?.powerpointID ||
            profile?.PowerPointID ||
            null
          }
          experienceData={
            Array.isArray(profile?.expertExperience)
              ? profile.expertExperience
              : []
          }
          data={{
            identityMode,
            projectType: profile?.projectType,
            profilePicture: profile?.profilePicture,
            expertDigitalID: profile?.expertDigitalID,
            expertName: profile?.expertName,
            position: profile?.position,
            location: profile?.location,
            region: profile?.region,
            language: profile?.language,
            totalExperience: profile?.totalExperience,
            availableComment: profile?.Available_comment,
            projectCurrency: profile?.projectCurrency,
            dailyRate: profile?.daily_rate,
            billingFrequency: profile?.billingFrequency,
            footNote: profile?.footNote,
            summary: profile?.summ,
            education: profile?.education,
            dimensions: [
              profile?.dimension1,
              profile?.dimension2,
              profile?.dimension3,
              profile?.dimension4,
              profile?.dimension5,
            ],
            ratings: [
              Number(profile?.rating1) || 0,
              Number(profile?.rating2) || 0,
              Number(profile?.rating3) || 0,
              Number(profile?.rating4) || 0,
              Number(profile?.rating5) || 0,
            ],
          }}
        />
      ))}

      <BulkPdfLastPage
        contactName={contactName}
        contactEmail={contactEmail}
      />
    </div>
  );
}

function waitForBulkImages(root) {
  const images = Array.from(
    root?.querySelectorAll?.("img") || []
  );

  return Promise.all(
    images.map((image) => {
      if (image.complete) {
        return Promise.resolve();
      }

      return new Promise((resolve) => {
        image.onload = resolve;
        image.onerror = resolve;
      });
    })
  );
}

function waitForBulkStyles(doc) {
  const stylesheetLinks = Array.from(
    doc.querySelectorAll('link[rel="stylesheet"]')
  );

  return Promise.all(
    stylesheetLinks.map((link) => {
      if (link.sheet) {
        return Promise.resolve();
      }

      return new Promise((resolve) => {
        const done = () => resolve();

        link.addEventListener("load", done, {
          once: true,
        });
        link.addEventListener("error", done, {
          once: true,
        });

        setTimeout(done, 3000);
      });
    })
  );
}

function copyBulkDocumentStyles(printWindow) {
  Array.from(
    document.querySelectorAll(
      'style, link[rel="stylesheet"]'
    )
  ).forEach((node) => {
    try {
      const clone = node.cloneNode(true);

      if (
        node.tagName === "LINK" &&
        node.href
      ) {
        clone.href = node.href;
      }

      printWindow.document.head.appendChild(clone);
    } catch (error) {
      console.error(
        "Failed to copy stylesheet into bulk PDF window:",
        error
      );
    }
  });
}

const BULK_PDF_PRINT_STYLE = `
  @page {
    size: 13.333333333in 7.5in;
    margin: 0;
  }

  html,
  body {
    width: auto !important;
    height: auto !important;
    min-height: 0 !important;
    margin: 0 !important;
    padding: 0 !important;
    overflow: visible !important;
    background: #ffffff !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }

  #pdp2-bulk-print-root {
    width: auto !important;
    height: auto !important;
    margin: 0 !important;
    padding: 0 !important;
    overflow: visible !important;
  }

  .pdp2-screen-only,
  [data-pdp2-print-hide="true"] {
    display: none !important;
  }

  .pdp2-print-only {
    display: block !important;
  }

  /* The normal Preview stylesheet fixes .pdp2-page-shell to one print page.
     The bulk deck is the only exception: it must be allowed to contain many
     otherwise-standard DigitalProfileSlide pages. */
  .pdp2-page-shell.pdp2-bulk-pdf-deck {
    width: auto !important;
    height: auto !important;
    min-height: 0 !important;
    margin: 0 !important;
    padding: 0 !important;
    overflow: visible !important;
    background: #ffffff !important;
  }

  .pdp2-bulk-pdf-deck > .pdp2-slide,
  .pdp2-bulk-pdf-deck > [data-pdp2-bulk-static-page] {
    width: 13.333333333in !important;
    height: 7.5in !important;
    min-width: 13.333333333in !important;
    min-height: 7.5in !important;
    max-width: 13.333333333in !important;
    max-height: 7.5in !important;
    margin: 0 !important;
    box-shadow: none !important;
    overflow: hidden !important;
    break-after: page !important;
    page-break-after: always !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }

  .pdp2-bulk-pdf-deck > :last-child {
    break-after: auto !important;
    page-break-after: auto !important;
  }

  .pdp2-bulk-pdf-deck
    [data-pdp2-bulk-static-page]
    > img {
    position: absolute !important;
    inset: 0 !important;
    width: 100% !important;
    height: 100% !important;
    max-width: none !important;
    max-height: none !important;
    object-fit: fill !important;
  }
`;

function freezeBulkSlideGeometry(sourceDeck, clonedDeck) {
  const sourceSlides = Array.from(
    sourceDeck.querySelectorAll(":scope > .pdp2-slide")
  );
  const clonedSlides = Array.from(
    clonedDeck.querySelectorAll(":scope > .pdp2-slide")
  );

  const sectionSelectors = [
    ".pdp2-summary-section",
    ".pdp2-matching-section",
    ".pdp2-experience-section",
    ".pdp2-education-section",
  ];

  sourceSlides.forEach((sourceSlide, slideIndex) => {
    const clonedSlide = clonedSlides[slideIndex];
    if (!clonedSlide) return;

    // The standard Preview slide is already laid out correctly in the active
    // document. Freeze those calculated section heights onto the clone so the
    // multi-page print wrapper cannot make Flexbox recalculate them differently.
    sectionSelectors.forEach((selector) => {
      const sourceSection = sourceSlide.querySelector(selector);
      const clonedSection = clonedSlide.querySelector(selector);

      if (!sourceSection || !clonedSection) return;

      const height = sourceSection.getBoundingClientRect().height;
      if (!Number.isFinite(height) || height <= 0) return;

      clonedSection.style.height = `${height}px`;
      clonedSection.style.flex = `0 0 ${height}px`;
    });

    // Keep the two 600px content columns at the exact same runtime height as
    // PreviewDigitalPPT as well. This is only a snapshot of the shared layout;
    // it does not introduce any new design dimensions.
    [".pdp2-center-column", ".pdp2-right-column"].forEach(
      (selector) => {
        const sourceColumn = sourceSlide.querySelector(selector);
        const clonedColumn = clonedSlide.querySelector(selector);

        if (!sourceColumn || !clonedColumn) return;

        const height = sourceColumn.getBoundingClientRect().height;
        if (!Number.isFinite(height) || height <= 0) return;

        clonedColumn.style.height = `${height}px`;
      }
    );
  });
}

async function prepareBulkPdfPrintWindow(
  printWindow,
  sourceHost,
  title
) {
  printWindow.document.open();
  printWindow.document.write(`
    <!doctype html>
    <html>
      <head>
        <meta charset="utf-8" />
        <title></title>
      </head>
      <body>
        <div id="pdp2-bulk-print-root"></div>
      </body>
    </html>
  `);
  printWindow.document.close();

  printWindow.document.title = title;

  copyBulkDocumentStyles(printWindow);

  const printStyle =
    printWindow.document.createElement("style");

  printStyle.textContent = BULK_PDF_PRINT_STYLE;
  printWindow.document.head.appendChild(printStyle);

  const sourceDeck = sourceHost.querySelector(
    ".pdp2-bulk-pdf-deck"
  );

  if (!sourceDeck) {
    throw new Error(
      "Bulk digital profile slides could not be rendered."
    );
  }

  const clonedDeck = sourceDeck.cloneNode(true);

  // Preserve the exact section allocation that the shared DigitalProfileSlide
  // calculated in the parent document before the multi-page deck is mounted in
  // the print window.
  freezeBulkSlideGeometry(sourceDeck, clonedDeck);

  const sourceFields = sourceDeck.querySelectorAll(
    "input, textarea, select"
  );
  const clonedFields = clonedDeck.querySelectorAll(
    "input, textarea, select"
  );

  sourceFields.forEach((sourceField, index) => {
    const clonedField = clonedFields[index];

    if (!clonedField) return;

    clonedField.value = sourceField.value;

    if (clonedField.tagName === "TEXTAREA") {
      clonedField.textContent = sourceField.value;
    }

    if (
      sourceField.type === "checkbox" ||
      sourceField.type === "radio"
    ) {
      clonedField.checked = sourceField.checked;
    }
  });

  // Match PreviewDigitalPPT.handleBrowserPdf(): the normal single-profile
  // PDF removes editing-only DOM before mounting the print snapshot instead
  // of merely relying on @media print to hide it. Doing the same here keeps
  // the Bulk snapshot structurally identical to the standard Preview PDF.
  clonedDeck
    .querySelectorAll(
      '[data-pdp2-print-hide="true"], .pdp2-screen-only'
    )
    .forEach((node) => node.remove());

  clonedDeck
    .querySelectorAll(".pdp2-print-only")
    .forEach((node) => {
      node.style.display = "block";
    });

  const printRoot =
    printWindow.document.getElementById(
      "pdp2-bulk-print-root"
    );

  printRoot.appendChild(clonedDeck);

  await waitForBulkStyles(printWindow.document);
  await waitForBulkImages(printWindow.document);

  if (printWindow.document.fonts?.ready) {
    try {
      await printWindow.document.fonts.ready;
    } catch (error) {
      console.error(
        "Could not wait for print fonts:",
        error
      );
    }
  }
}


export default function MSbuttons({
  project_id,
  expertIds,
  clientLogo,
  setAddLogoPopUp,
  continueWithoutLogo,
  setContinueWithoutLogo,
  project_name,
  client_name,
  setEmailDetails,
  setComposeEmail,
}) {
  const urlContextValue = useContext(UrlContext);
  const { API_URL, URI } = urlContextValue;
  // const { checkAccessToken } = useContext(UserContext);
  const { userData } = useContext(UserContext);

  const [loadingPopup, setLoadingPopup] = useState(false);
  const [filePath, setFilePath] = useState("");
  const [showPdfUpload, setShowPdfUpload] = useState(false);
  const [pdfFile, setPdfFile] = useState(null);
  const [pdfDragActive, setPdfDragActive] = useState(false);
  const [pdfUploading, setPdfUploading] = useState(false);
  const [showBulkPdfSelection, setShowBulkPdfSelection] = useState(false);
  const [bulkPdfSectionVisibility, setBulkPdfSectionVisibility] = useState(
    () => ({ ...DEFAULT_BULK_PDF_SECTION_VISIBILITY })
  );
  const [bulkPdfIdentityMode, setBulkPdfIdentityMode] = useState("id");
  const [bulkPdfPreviewProfiles, setBulkPdfPreviewProfiles] = useState([]);
  const [bulkPdfPreviewLoading, setBulkPdfPreviewLoading] = useState(false);
  const [bulkPdfPreviewError, setBulkPdfPreviewError] = useState("");

  const checkForLogo = () => {
    setAddLogoPopUp(true);
  };

  function decodeJwt(token) {
    try {
      const base64Url = token.split(".")[1];
      const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split("")
          .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
          .join("")
      );
      return JSON.parse(jsonPayload);
    } catch (err) {
      console.error("❌ Failed to decode token:", err);
      return null;
    }
  }

  const handleBulkInmailConnect = async (type) => {
    setLoadingPopup(true);
    let url;
    let connectionType;

    if (type === "inmail") {
      url = `${URI}helper/send-bulk-inmail`;
      connectionType = "send_bulk_inmail";
    } else if (type === "connect") {
      url = `${URI}helper/send-bulk-connect`;
      connectionType = "send_bulk_connect";
    } else {
      setLoadingPopup(false);
      return;
    }

    const consulData = {
      expert_id: expertIds,
      project_id,
      project_name,
    };
    const ephToken = localStorage.getItem("eph-token");
    const token = JSON.parse(ephToken).value;

    const decodedToken = decodeJwt(token);

    try {
      const result = await ensureConnectionAndExecute(
        connectionType,
        async () => {
          const response = await fetch(url, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "x-access-token": token,
            },
            body: JSON.stringify({
              token: decodedToken?.preferred_username,
              expertData: consulData,
            }),
          });

          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          return await response.json();
        }
      );

      if (!result) {
        throw new Error("No response received from server");
      }

      const actionLabel = type === "inmail" ? "InMail" : "Connect";
      const estimateTimeout = Math.max(
        60000,
        (result.total || expertIds.length || 1) * 20000
      );

      if (result.status === "exception") {
        Swal.fire({
          icon: "info",
          title: "Error!",
          text: "Something went wrong!",
        });
        return;
      }

      if (result.status === "error") {
        if (result.message === "User not connected") {
          Swal.fire({
            icon: "error",
            title: "User not connected!",
            text: "Please refresh the page and update the project list on the extension!",
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: result.message || "Something went wrong!",
          });
        }
        return;
      }

      if (result.status === "queued") {
        const finalState = await pollTaskStatus(URI, result.task_id, token, {
          timeoutMs: estimateTimeout,
          intervalMs: 4000,
        });

        if (finalState.status === "success") {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: `${actionLabel} task completed successfully!`,
          });
        } else if (finalState.status === "timeout") {
          Swal.fire({
            icon: "warning",
            title: "Timeout",
            text: "The extension did not confirm completion in time. Please verify in the extension and try again.",
          });
        } else {
          Swal.fire({
            icon: "error",
            title: `${actionLabel} failed`,
            text: finalState.error || `The extension reported an error while processing the ${actionLabel.toLowerCase()} task.`,
          });
        }
        return;
      }

      if (result.status === "success") {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: `${actionLabel} task completed successfully!`,
        });
        return;
      }

      Swal.fire({
        icon: "warning",
        title: "Unexpected response",
        text: "Received an unexpected status from the server.",
      });
    } catch (error) {
      console.error("❌ Error while handling bulk task:", error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: error.message || "Something went wrong!",
      });
    } finally {
      setLoadingPopup(false);
    }
  };

  const bulkEmailHandler = (type) => {
    setLoadingPopup(true);
    const consulData = {
      expert_id: expertIds,
      project_id,
      project_name,
    };
    {
      const tokenObj = localStorage.getItem("eph-token");
      const token = JSON.parse(tokenObj).value;
      let url;
      if (type === "email") {
        url = `${API_URL}send-bulk-email`;
      } else if (type === "followUp") {
        url = `${API_URL}send-bulk-followUp-email`;
      }
      fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
        body: JSON.stringify(consulData),
      })
        .then((res) => res.json())
        .then((data) => {
          setLoadingPopup(false);
          if (data.status === "success") {
            setEmailDetails(data.emailDetails);
            setComposeEmail(true);
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
            });
          }
        });
    }
  };

  const fileCreationHandler = async (format) => {
    const fileLabel =
      FILE_FORMAT_LABELS[format] || "File";

    Swal.fire({
      title: `Generating ${fileLabel}`,
      text: "Please wait while the file is being prepared...",
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    try {
      const authToken =
        localStorage.getItem("accesstoken");
      const tokenObj =
        localStorage.getItem("eph-token");
      const token = JSON.parse(tokenObj).value;

      const response = await fetch(
        `${API_URL}create-full-${format}/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-access-token": token,
          },
          body: JSON.stringify({
            expertIds,
            project_id,
            authToken,
          }),
        }
      );

      const data = await response.json();

      if (
        !response.ok ||
        data.status !== "success"
      ) {
        throw new Error(
          data.message ||
            `Failed to generate ${fileLabel}.`
        );
      }

      setFilePath(data.filePath);

      window.open(
        data.filePath,
        "_blank",
        "rel=noopener noreferrer"
      );

      await Swal.fire({
        icon: "success",
        title: `${fileLabel} ready`,
        text: `The generated ${fileLabel} file has been opened in a new tab.`,
        timer: 1800,
        showConfirmButton: false,
      });
    } catch (error) {
      console.error(
        `Error generating ${fileLabel}:`,
        error
      );

      Swal.fire({
        icon: "error",
        title: `${fileLabel} generation failed`,
        text:
          error.message ||
          `Failed to generate ${fileLabel}.`,
      });
    }
  };

  const createWordHandler = () => {
    fileCreationHandler("word");
  };

  const createExcelHandler = () => {
    fileCreationHandler("excel");
  };

  const createPPTHandler = () => {
    if (clientLogo || continueWithoutLogo) {
      fileCreationHandler("ppt");
    } else {
      checkForLogo();
    }
  };

  const toggleBulkPdfSection = (key) => {
    setBulkPdfSectionVisibility((previous) => ({
      ...previous,
      [key]: !previous[key],
    }));
  };

  const handleBulkPdfIdentitySelection = (mode) => {
    const isAlreadyActive =
      bulkPdfSectionVisibility.identity && bulkPdfIdentityMode === mode;

    if (isAlreadyActive) {
      setBulkPdfIdentityMode(null);
      setBulkPdfSectionVisibility((previous) => ({
        ...previous,
        identity: false,
      }));
      return;
    }

    setBulkPdfIdentityMode(mode);
    setBulkPdfSectionVisibility((previous) => ({
      ...previous,
      identity: true,
    }));
  };

  const openBulkPdfSelection = async () => {
    if (!Array.isArray(expertIds) || expertIds.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "No profiles selected",
        text: "Please select at least one digital profile first.",
      });
      return;
    }

    setShowBulkPdfSelection(true);
    setBulkPdfPreviewProfiles([]);
    setBulkPdfPreviewError("");
    setBulkPdfPreviewLoading(true);

    try {
      const tokenObj = localStorage.getItem("eph-token");
      const token = tokenObj ? JSON.parse(tokenObj).value : null;

      // Fetch all selected profiles for the full live PDF preview. Experience is
      // explicitly requested so turning that section on never requires another
      // round-trip while the user is adjusting the layout.
      const previewSectionVisibility = Object.fromEntries(
        Object.keys(DEFAULT_BULK_PDF_SECTION_VISIBILITY).map((key) => [key, true])
      );

      const response = await fetch(
        `${API_URL}fetch-digital-profiles-for-pdf`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            ...(token ? { "x-access-token": token } : {}),
          },
          body: JSON.stringify({
            projectID: project_id,
            expertIDs: expertIds,
            sectionVisibility: previewSectionVisibility,
            identityMode: bulkPdfIdentityMode || "id",
          }),
        }
      );

      const data = await response.json();

      if (!response.ok || data.status !== "success") {
        throw new Error(
          data.text || data.message || "Failed to load the PDF preview profile."
        );
      }

      const previewProfiles = Array.isArray(data.powerpointData)
        ? data.powerpointData
        : [];

      if (!previewProfiles.length) {
        throw new Error("No digital profiles were returned for the preview.");
      }

      setBulkPdfPreviewProfiles(previewProfiles);
    } catch (error) {
      console.error("Error loading bulk PDF live preview:", error);
      setBulkPdfPreviewError(
        error.message || "The live preview could not be loaded."
      );
    } finally {
      setBulkPdfPreviewLoading(false);
    }
  };

  const selectPdfFile = (file) => {
    if (!file) return;

    const isPdf =
      file.type === "application/pdf" ||
      file.name?.toLowerCase().endsWith(".pdf");

    if (!isPdf) {
      Swal.fire({
        icon: "warning",
        title: "PDF required",
        text: "Please select a PDF file.",
      });
      return;
    }

    setPdfFile(file);
  };

  const handlePdfDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setPdfDragActive(false);

    if (pdfUploading) return;

    const files = Array.from(event.dataTransfer.files || []);

    if (files.length > 1) {
      Swal.fire({
        icon: "warning",
        title: "One PDF at a time",
        text: "Please upload only one PDF file.",
      });
      return;
    }

    selectPdfFile(files[0]);
  };

  const closePdfUpload = () => {
    if (pdfUploading) return;

    setShowPdfUpload(false);
    setPdfFile(null);
    setPdfDragActive(false);
  };

  const uploadPdfToSharePoint = async () => {
    if (!pdfFile) {
      Swal.fire({
        icon: "warning",
        title: "No PDF selected",
        text: "Please select or drop the PDF file first.",
      });
      return;
    }

    const authToken = localStorage.getItem("accesstoken");
    const formData = new FormData();

    formData.append("file", pdfFile);
    formData.append("fileName", pdfFile.name);
    formData.append("authToken", authToken || "");
    formData.append("projectID", String(project_id));

    try {
      setPdfUploading(true);

      const response = await fetch(
        `${API_URL}upload-file-to-sharePoint`,
        {
          method: "POST",
          body: formData,
        }
      );

      const data = await response.json();

      if (
        !response.ok ||
        data.status !== "success"
      ) {
        throw new Error(
          data.text ||
            data.message ||
            "Failed to upload PDF to SharePoint."
        );
      }

      setShowPdfUpload(false);
      setPdfFile(null);
      setPdfDragActive(false);

      Swal.fire({
        icon: "success",
        title: "PDF uploaded",
        text: "The PDF has been uploaded to SharePoint.",
      });
    } catch (error) {
      console.error(
        "Error uploading PDF to SharePoint:",
        error
      );

      Swal.fire({
        icon: "error",
        title: "Upload failed",
        text:
          error.message ||
          "Failed to upload the PDF to SharePoint.",
      });
    } finally {
      setPdfUploading(false);
    }
  };

  const createBulkPdfHandler = async (pdfSelection) => {
    if (!Array.isArray(expertIds) || expertIds.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "No profiles selected",
        text: "Please select at least one digital profile first.",
      });
      return;
    }

    const selectedSectionVisibility = {
      ...DEFAULT_BULK_PDF_SECTION_VISIBILITY,
      ...(pdfSelection?.sectionVisibility || {}),
    };
    const selectedIdentityMode = selectedSectionVisibility.identity
      ? pdfSelection?.identityMode || "id"
      : null;

    Swal.fire({
      title: "Generating bulk PDF",
      text: `Preparing ${expertIds.length} digital profile${
        expertIds.length === 1 ? "" : "s"
      }...`,
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    let renderHost = null;
    let renderRoot = null;

    try {
      const tokenObj =
        localStorage.getItem("eph-token");
      const token = tokenObj
        ? JSON.parse(tokenObj).value
        : null;

      /*
       * 1. Fetch everything first while the parent page remains active.
       */
      const response = await fetch(
        `${API_URL}fetch-digital-profiles-for-pdf`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            ...(token
              ? { "x-access-token": token }
              : {}),
          },
          body: JSON.stringify({
            projectID: project_id,
            expertIDs: expertIds,
            sectionVisibility: selectedSectionVisibility,
            identityMode: selectedIdentityMode,
          }),
        }
      );

      const data = await response.json();

      if (
        !response.ok ||
        data.status !== "success"
      ) {
        throw new Error(
          data.text ||
            data.message ||
            "Failed to fetch digital profiles."
        );
      }

      const profiles = Array.isArray(
        data.powerpointData
      )
        ? data.powerpointData
        : [];

      if (!profiles.length) {
        throw new Error(
          "No digital profiles were returned."
        );
      }

      /*
       * 2. Render the full read-only PDF deck in the CURRENT page first.
       *
       * The previous implementation opened the new tab before this step.
       * Browsers pause/throttle requestAnimationFrame in a background tab,
       * which meant this parent-page render could remain suspended until
       * the user returned to the parent tab.
       *
       * flushSync commits the hidden deck immediately while this tab is
       * active, so there is no background-tab dependency.
       */
      renderHost = document.createElement("div");
      renderHost.setAttribute(
        "data-pdp2-bulk-render-host",
        "true"
      );

      Object.assign(renderHost.style, {
        position: "fixed",
        left: "-100000px",
        top: "0",
        width: "1280px",
        visibility: "hidden",
        pointerEvents: "none",
        zIndex: "-1",
      });

      document.body.appendChild(renderHost);

      renderRoot = createRoot(renderHost);

      flushSync(() => {
        renderRoot.render(
          <UrlContext.Provider value={urlContextValue}>
            <BulkDigitalProfileDeck
              profiles={profiles}
              projectName={project_name}
              clientName={client_name}
              contactName={userData?.fullname || ""}
              contactEmail={userData?.email || ""}
              projectType={profiles?.[0]?.projectType}
              sectionVisibility={selectedSectionVisibility}
              identityMode={selectedIdentityMode}
            />
          </UrlContext.Provider>
        );
      });

      // Let shared-slide effects (notably Education auto-sizing) commit before
      // cloning the rendered deck into the print window.
      await new Promise((resolve) => {
        requestAnimationFrame(() => requestAnimationFrame(resolve));
      });

      await waitForBulkImages(renderHost);

      if (document.fonts?.ready) {
        try {
          await document.fonts.ready;
        } catch (error) {
          console.error(
            "Could not wait for PDF fonts:",
            error
          );
        }
      }

      const makeSafePdfFilePart = (value, fallback) => {
        const cleaned = String(value || fallback || "")
          .replace(/[\\/:*?"<>|]+/g, " ")
          .replace(/\s+/g, " ")
          .trim();

        return cleaned;
      };

      const now = new Date();
      const dateMonthYear = `${String(now.getDate()).padStart(2, "0")}${new Intl.DateTimeFormat(
        "en-US",
        { month: "short" }
      ).format(now)}${String(now.getFullYear()).slice(-2)}`;

      const bulkPdfFileName = `expertpowerhouse_${makeSafePdfFilePart(
        client_name,
        "Client"
      )}_${makeSafePdfFilePart(
        project_name,
        "Project"
      )}_${dateMonthYear}`;

      /*
       * 3. At this point the backend data, React deck and images are ready.
       *
       * Ask for one explicit click before opening the print window.
       * This prevents browser popup blockers from rejecting window.open()
       * after the asynchronous fetch/render work.
       */
      const readyResult = await Swal.fire({
        icon: "success",
        title: "Bulk PDF ready",
        text: `${profiles.length} digital profile${
          profiles.length === 1 ? "" : "s"
        } prepared and ready to print.`,
        confirmButtonText: "Open PDF",
        showCancelButton: true,
        cancelButtonText: "Cancel",
        reverseButtons: true,
      });

      if (!readyResult.isConfirmed) {
        renderRoot.unmount();
        renderRoot = null;

        renderHost.remove();
        renderHost = null;

        return;
      }

      /*
       * 4. Only now open the new window.
       * This click is a direct user action, so popup blockers should allow it.
       */
      const printWindow = window.open(
        "",
        "_blank",
        "width=1400,height=900"
      );

      if (!printWindow) {
        throw new Error(
          "The PDF window was blocked. Please allow popups for this site and try again."
        );
      }

      Swal.fire({
        title: "Opening PDF",
        text: "Preparing the print window...",
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      try {
        await prepareBulkPdfPrintWindow(
          printWindow,
          renderHost,
          bulkPdfFileName
        );

        renderRoot.unmount();
        renderRoot = null;

        renderHost.remove();
        renderHost = null;

        Swal.close();

        printWindow.onafterprint = () => {
          setPdfFile(null);
          setPdfDragActive(false);
          setShowPdfUpload(true);

          try {
            printWindow.close();
          } catch (error) {
            console.error(
              "Could not close bulk PDF window:",
              error
            );
          }
        };

        setTimeout(() => {
          printWindow.focus();
          printWindow.print();
        }, 250);
      } catch (printError) {
        try {
          printWindow.close();
        } catch (closeError) {
          console.error(
            "Could not close failed bulk PDF window:",
            closeError
          );
        }

        throw printError;
      }
    } catch (error) {
      console.error(
        "Error generating bulk digital profile PDF:",
        error
      );

      if (renderRoot) {
        renderRoot.unmount();
      }

      if (renderHost?.isConnected) {
        renderHost.remove();
      }

      Swal.fire({
        icon: "error",
        title: "Bulk PDF generation failed",
        text:
          error.message ||
          "Failed to generate the bulk PDF.",
      });
    }
  };


  useEffect(() => {
    if (continueWithoutLogo) {
      createPPTHandler();
      setContinueWithoutLogo(false);
      setAddLogoPopUp(false);
    }
  }, [continueWithoutLogo]);

  return (
    <>
      <div className="dropdown">
        <button
          className="btn dropdown-toggle"
          type="button"
          id="fileGenerationDropdownButton"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          Files
        </button>

        <div
          className="dropdown-menu"
          aria-labelledby="fileGenerationDropdownButton"
          style={{
            width: "200px",
          }}
        >
          <button
            className="btn"
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "10px",
              textAlign: "center",
            }}
            onClick={createWordHandler}
          >
            <FileText size={16} strokeWidth={1.9} />
            <span>Word</span>
          </button>

          <button
            className="btn"
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "10px",
              textAlign: "center",
            }}
            onClick={createPPTHandler}
          >
            <Presentation size={16} strokeWidth={1.9} />
            <span>PPTX</span>
          </button>

          <button
            className="btn"
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "10px",
              textAlign: "center",
            }}
            onClick={createExcelHandler}
          >
            <FileSpreadsheet size={16} strokeWidth={1.9} />
            <span>Excel</span>
          </button>

          <button
            className="btn"
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "10px",
              textAlign: "center",
            }}
            onClick={openBulkPdfSelection}
          >
            <FileDown size={16} strokeWidth={1.9} />
            <span>Bulk PDF</span>
          </button>
        </div>
      </div>

      <div className="dropdown">
        <button
          className="btn dropdown-toggle"
          type="button"
          id="dropdownMenuButton"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          // style={{ marginBottom: "10px" }}
        >
          Contact
        </button>

        <div
          className="dropdown-menu"
          aria-labelledby="dropdownMenuButton"
          style={{ width: "200px", textAlign: "center" }}
        >
          <button
            className="btn"
            style={{ width: "100%" }}
            onClick={() => bulkEmailHandler("email")}
          >
            First outreach email
          </button>
          <button
            className="btn"
            style={{ width: "100%" }}
            onClick={() => bulkEmailHandler("followUp")}
          >
            Follow-up email
          </button>
          <button
            className="btn"
            style={{ width: "100%" }}
            onClick={() => handleBulkInmailConnect("inmail")}
          >
            Inmail
          </button>
          <button
            className="btn"
            style={{ width: "100%" }}
            onClick={() => handleBulkInmailConnect("connect")}
          >
            Connect
          </button>
        </div>
      </div>

      <BulkPdfSectionSelectionModal
        open={showBulkPdfSelection}
        sectionVisibility={bulkPdfSectionVisibility}
        identityMode={bulkPdfIdentityMode}
        previewProfiles={bulkPdfPreviewProfiles}
        previewLoading={bulkPdfPreviewLoading}
        previewError={bulkPdfPreviewError}
        projectName={project_name}
        clientName={client_name}
        contactName={userData?.fullname || ""}
        contactEmail={userData?.email || ""}
        onToggleSection={toggleBulkPdfSection}
        onIdentitySelection={handleBulkPdfIdentitySelection}
        onClose={() => setShowBulkPdfSelection(false)}
        onConfirm={() => {
          const selection = {
            sectionVisibility: { ...bulkPdfSectionVisibility },
            identityMode: bulkPdfSectionVisibility.identity
              ? bulkPdfIdentityMode || "id"
              : null,
          };

          flushSync(() => {
            setShowBulkPdfSelection(false);
          });

          createBulkPdfHandler(selection);
        }}
      />

      {showPdfUpload && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40 px-4 backdrop-blur-sm">
          <div className="w-full max-w-lg overflow-hidden rounded-3xl bg-white shadow-2xl">
            {/* Header */}
            <div className="flex items-start justify-between gap-4 border-b border-slate-200 px-6 py-4">
              <div className="min-w-0">
                <h3 className="text-base font-bold text-slate-800">
                  Upload saved PDF
                </h3>

                <p className="mt-1 text-xs leading-5 text-slate-500">
                  If you saved the PDF from the print window, upload it here to
                  store it in SharePoint.
                </p>
              </div>

              <button
                type="button"
                disabled={pdfUploading}
                onClick={closePdfUpload}
                className="
                  flex h-8 w-8 shrink-0 items-center justify-center
                  rounded-full !border-0 !bg-transparent
                  !p-0 !text-xl !font-normal !leading-none
                  !text-slate-400
                  transition
                  hover:!bg-slate-100 hover:!text-slate-700
                  disabled:cursor-not-allowed disabled:opacity-40
                "
                aria-label="Close PDF upload"
                title="Close"
              >
                ×
              </button>
            </div>

            {/* Body */}
            <div className="p-6">
              <label
                onDragEnter={(event) => {
                  if (pdfUploading) return;

                  event.preventDefault();
                  event.stopPropagation();
                  setPdfDragActive(true);
                }}
                onDragOver={(event) => {
                  if (pdfUploading) return;

                  event.preventDefault();
                  event.stopPropagation();
                  setPdfDragActive(true);
                }}
                onDragLeave={(event) => {
                  event.preventDefault();
                  event.stopPropagation();
                  setPdfDragActive(false);
                }}
                onDrop={handlePdfDrop}
                className={[
                  "relative flex min-h-[230px] flex-col items-center justify-center",
                  "rounded-2xl border-2 border-dashed px-6 text-center transition",
                  pdfUploading
                    ? "cursor-default border-slate-200 bg-slate-50"
                    : pdfDragActive
                      ? "cursor-pointer border-[#365561] bg-[#365561]/5"
                      : "cursor-pointer border-slate-300 bg-slate-50 hover:border-[#365561]/60 hover:bg-slate-100",
                ].join(" ")}
              >
                <input
                  type="file"
                  accept=".pdf,application/pdf"
                  className="hidden"
                  disabled={pdfUploading}
                  onChange={(event) => {
                    const file = event.target.files?.[0];

                    selectPdfFile(file);

                    event.target.value = "";
                  }}
                />

                {pdfUploading ? (
                  /* Uploading state */
                  <div className="flex flex-col items-center justify-center">
                    <span
                      className="
                        h-10 w-10 animate-spin rounded-full
                        border-[3px] border-slate-200
                        border-t-[#365561]
                      "
                    />

                    <p className="mt-4 text-sm font-semibold text-slate-700">
                      Uploading PDF...
                    </p>

                    <p className="mt-1 text-xs text-slate-400">
                      Saving the file to SharePoint
                    </p>

                    {pdfFile?.name && (
                      <p className="mt-4 max-w-[320px] truncate text-xs font-medium text-slate-500">
                        {pdfFile.name}
                      </p>
                    )}
                  </div>
                ) : pdfFile ? (
                  /* Selected PDF state */
                  <>
                    <div className="relative mb-4 flex h-16 w-14 items-center justify-center">
                      <FileText
                        size={52}
                        strokeWidth={1.35}
                        className="text-[#365561]"
                      />

                      <span
                        className="
                          absolute -bottom-1 left-1/2
                          -translate-x-1/2
                          rounded-md bg-[#365561]
                          px-1.5 py-0.5
                          text-[8px] font-bold tracking-wide text-white
                        "
                      >
                        PDF
                      </span>
                    </div>

                    <p className="max-w-full break-all text-sm font-semibold text-slate-700">
                      {pdfFile.name}
                    </p>

                    <p className="mt-1 text-xs text-slate-400">
                      {(pdfFile.size / 1024 / 1024).toFixed(2)} MB
                    </p>

                    <p className="mt-4 text-xs font-semibold text-[#365561]">
                      Click or drop another PDF to replace it
                    </p>
                  </>
                ) : (
                  /* Empty state */
                  <>
                    <FileDown
                      size={36}
                      strokeWidth={1.5}
                      className="mb-3 text-[#365561]"
                    />

                    <p className="text-sm font-semibold text-slate-700">
                      Drag &amp; drop your PDF here
                    </p>

                    <p className="my-2 text-xs text-slate-400">
                      or
                    </p>

                    <span
                      className="
                        rounded-xl bg-[#365561]
                        px-4 py-2
                        text-xs font-semibold text-white shadow-sm
                      "
                    >
                      Select from computer
                    </span>

                    <p className="mt-4 text-[10px] text-slate-400">
                      One PDF file at a time
                    </p>
                  </>
                )}
              </label>
            </div>

            {/* Footer */}
            <div className="flex justify-end gap-2 border-t border-slate-200 bg-slate-50 px-6 py-3">
              <button
                type="button"
                disabled={pdfUploading}
                onClick={closePdfUpload}
                className="
                  rounded-xl
                  !border !border-slate-200
                  !bg-white
                  px-4 py-2
                  !text-sm !font-semibold !text-slate-600
                  transition
                  hover:!border-slate-300 hover:!bg-slate-100 hover:!text-slate-700
                  disabled:cursor-not-allowed disabled:opacity-40
                "
              >
                Skip
              </button>

              <button
                type="button"
                disabled={!pdfFile || pdfUploading}
                onClick={uploadPdfToSharePoint}
                className="
                  inline-flex min-w-[120px] items-center justify-center gap-2
                  rounded-xl
                  !border-0
                  !bg-[#365561]
                  px-4 py-2
                  !text-sm !font-semibold !text-white
                  transition
                  hover:!bg-[#2e4a54] hover:!text-white
                  disabled:cursor-not-allowed
                  disabled:!bg-slate-300 disabled:!text-white
                  disabled:opacity-100
                "
              >
                {pdfUploading && (
                  <span
                    className="
                      h-4 w-4 animate-spin rounded-full
                      border-2 border-white/40 border-t-white
                    "
                  />
                )}

                {pdfUploading ? "Uploading..." : "Upload"}
              </button>
            </div>
          </div>
        </div>
      )}

      {loadingPopup && (
        <div className="deletePrj-popup-wrapper">
          <div className="tab-pane fade show deletePrj-div">
            <center>
              <p style={{ fontSize: "18px" }}>Please wait . . .</p>
              <br />
              <img
                src={LoadingIcon}
                alt=""
                style={{ width: "50px", marginRight: "5px" }}
              />
            </center>
          </div>
        </div>
      )}
    </>
  );
}